/* eslint-disable react-hooks/rules-of-hooks */
// ⚠ Règle désactivée pour CE fichier uniquement (31.07.2026), pas par confort :
// eslint-plugin-react-hooks 1.7.0 (épinglé par react-scripts 3.4) compte les
// chemins d'exécution en Number. Ce composant en a ~4·10³⁵ : au-delà de 2⁵³ le
// produit `pathsFromStart × pathsToEnd` ne retombe plus exactement sur le total,
// et le plugin déclare « hook appelé conditionnellement » de façon ALÉATOIRE —
// ajouter ou retirer un `&&` dans le rendu suffit à faire basculer les 20 hooks
// du composant en erreur (build cassé) sans qu'aucun hook n'ait bougé.
// Vérifié : eslint-plugin-react-hooks 4.6.2 (compte en BigInt, calcul exact) ne
// signale RIEN sur ce fichier, ni avant ni après le retrait du verrou heures.
// On ne peut pas l'installer ici : npm 6 (Node 14) imbrique la 1.7.0 sous
// react-scripts, qui gagne. Fix durable = react-scripts/npm plus récents.
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import {
	deleteAtelierFile,
	deleteAtelierFileReset,
	fetchAtelier,
	fetchAtelierCommentaires,
	fetchAtelierEntite,
	fetchAtelierLignes,
	fetchAtelierReset,
	fetchClient,
	fetchClientVehicules,
	postAtelier,
	postAtelierReset,
	postAtelierErrorField,
	postAtelierFiles,
	postAtelierFilesReset,
	fetchAtelierFiles,
	fetchAtelierQuantites,
	fetchAtelierQuantitesReset,
	postAtelierDocRestitution,
	postAtelierDocRestitutionReset,
	atelierDeleteDocRestitution,
} from "../../store/actions/atelierActions"
import CustomModal, {
	LoadingCustomModal,
	SavingCustomModal,
} from "../basics/interface/CustomModal"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"
import InputV2 from "../basics/input/InputV2"
import SelectV2 from "../basics/input/SelectV2"
import "./AtelierV2.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faCar,
	faCrown,
	faExclamationTriangle,
	faHandshake,
	faHighlighter,
	faPlus,
	faSitemap,
	faTrash,
	faTruckPickup,
} from "@fortawesome/free-solid-svg-icons"
import { QRCodeSVG } from "qrcode.react"
import { generalStyles } from "../styles/styles"
import { useAtelierPermissions } from "../../hooks/ateliers"
import {
	transactionEstFacture,
	moyenFacturePresent,
} from "../../hooks/moyenPaiement"
import { useQuitGuard } from "../../hooks/useQuitGuard"
import useFeuilletage from "../../hooks/useFeuilletage"
import { getOpenerId } from "../../utilities/session"
import {
	ATELIER_ETATS_CHOICES,
	ATELIER_ETATS_SVP_CHOICES,
	ATELIER_ETAT_CLOS,
	ATELIER_ETAT_DEVIS,
	ATELIER_ETAT_DEVIS_A_FAIRE,
	ATELIER_ETAT_DEVIS_ACCEPTE,
	ATELIER_ETAT_DEVIS_REFUSE,
	ATELIER_ETAT_A_RESTITUER,
	ATELIER_ETAT_CONTROLE_AVANT_FACTURATION,
	ATELIER_ETAT_EN_ATTENTE_CLIENT,
	ATELIER_ETAT_OK_POUR_FACTURATION,
	ATELIER_ETAT_TRAVAUX_EN_COURS,
	ATELIER_ETAT_TRAVAUX_TERMINES,
	isValidDate,
	isValidDateUSA,
	round100,
	round20,
	typeNumber,
	HTtoTTC,
	TTCtoHT,
	normalizePdf,
	dateFrToISO,
	dateISOToFr,
} from "../../utilities/Addons"
import { getBaseAtelier } from "../../utilities/defaultObjects"
import { COLORS } from "../../utilities/Constants"
import TransactionsCardV2 from "../others/TransactionsCardV2"
import HistoriqueCardV2 from "../others/HistoriqueCardV2"
import {
	ENTITE_TYPE_CLIENT_PASSAGE,
	ENTITE_TYPE_MASTER,
	ENTITE_TYPE_PERSONNE_PHYSIQUE,
} from "../dashboard/entite/Entite"
import {
	ATELIER_LIGNE_TYPE_AUTRE,
	ATELIER_LIGNE_TYPE_FOURNITURE,
	ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
	ATELIER_LIGNE_TYPE_SUPPLEMENTAIRE,
	PAYE_PAR_ASSURANCE,
	PAYE_PAR_CLIENT,
	PAYE_PAR_MASTER,
	getBaseAtelierLigne,
} from "./AtelierLigneV2"
import AtelierLigneRow, {
	AtelierLigneHeader,
	buildColConfig,
} from "./AtelierLigneRow"
import { useGroups } from "../../hooks/groups"
import { filterEmployesGroupe } from "../../utilities/employes"
import { useSortableLignes } from "../../hooks/useSortableLignes"
import { ENTITE_TYPE_SOCIETE } from "../dashboard/entite/Entite"
import { useTarif } from "../../hooks/useTarif"
import {
	EMAIL_DOMAINE_ATELIER,
	EMAIL_TEMPLATE_CODE_DEVIS,
	fetchEmailDocuments,
	fetchEmailTemplates,
	fetchEmails,
	postEmail,
} from "../../store/actions/emailActions"
import {
	EMAIL_DESTINATAIRE_ASSURANCE,
	EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
	EMAIL_DESTINATAIRE_CLIENT_SOCIETE,
	EMAIL_DESTINATAIRE_EXPERT,
	EMAIL_DESTINATAIRE_LIBRE,
	EMAIL_DESTINATAIRE_SOUS_TRAITANT,
} from "../../utilities/Addons"
import { ATELIER_ETAT_EN_ATTENTE_PAIEMENT } from "../../utilities/Addons"
import {
	mergeTransactionsV2,
	appliquerPerte,
	avecServeur,
	causeNonSupprimable,
	champsModifiables,
	consequencesTransactions,
	niveauTransactions,
	regleDatation,
	BOSS,
} from "../../utilities/transactionsV2"
import { useMoyenPaiementFacture } from "../../hooks/moyenPaiement"
import AtelierSousTraitantsModalV2 from "./AtelierSousTraitantsModalV2"
import AtelierInventaireModalV2 from "./AtelierInventaireModalV2"
import AtelierModeleModalV2 from "./AtelierModeleModalV2"
import { fetchAtelierModeles } from "../../store/actions/atelierModeleActions"
import AtelierFicheHeuresV2 from "./composant_fiche/AtelierFicheHeuresV2"
import AddTransactionModalV2 from "./AddTransactionModalV2"
import AtelierSousTraitantV2 from "./AtelierSousTraitantV2"
import EmailModalV2 from "../others/EmailModalV2"
import EmailListV2 from "../others/EmailListV2"
import AtelierClientVehiculeCardV2 from "./AtelierClientVehiculeCardV2"
import AtelierVehiculeDocumentsCardV2 from "./AtelierVehiculeDocumentsCardV2"
import VehiculeV2 from "../dashboard/configuration/VehiculeV2"
import {
	fetchVehiculeFicheEntretien,
	putVehiculeFicheEntretien,
} from "../../store/actions/autreActions"
import { useRights } from "../../hooks/rights"
import { frToIso } from "../../store/reducers/masterReducer"
import {
	ATELIER_AUDATEX,
	ATELIER_FILE_TYPE_APRES_REPARATION,
	ATELIER_FILE_TYPE_AVANT_REPARATION,
	ATELIER_FILE_TYPE_BULLETIN_LIVRAISON,
	ATELIER_FILE_TYPE_CALCUL_REPARATION,
	ATELIER_FILE_TYPE_DEVIS,
	ATELIER_FILE_TYPE_DEVIS_SIGNE,
	ATELIER_FILE_TYPE_PHOTO_PIECE,
	ATELIER_FILE_TYPE_AUTRE,
	ATELIER_PHOTO_FACTURE,
	getBaseTransactionV2,
} from "../../store/reducers/atelierReducer"
import FileRenderer, {
	AddFileTile,
	PendingFileCard,
} from "../others/FileRenderer"
import { PdfSlot } from "../basics/interface/AppPdfs"
import FilteredSelectV2 from "../basics/input/FilteredSelectV2"
import AppBtnDownloadPdf, {
	downloadPdfFromResponse,
} from "../basics/button/AppBtnDownloadPdf"
import { URL, handleErrors } from "../../store/actions/depannageActions"
import { catchApiError } from "../../store/actions/apiHelpers"
import SaveAtelierV2 from "./SaveAtelierV2"
import AtelierModalQuantitesV2 from "./AtelierModalQuantitesV2"
import FacturationCustomModalV2 from "./FacturationCustomModalV2"
import { compterNonEnregistrees } from "../others/FacturationModalV2"
import { marqueurFicheLiee } from "../../utilities/ficheLiee"
import AtelierCloreModalV2 from "./AtelierCloreModalV2"
import useFicheVerrou from "../../hooks/useFicheVerrou"
import {
	BandeauFicheClose,
	BandeauLectureSeule,
	BoutonDemanderMain,
} from "../others/FicheVerrou"
import AtelierSwitchAssuranceModalV2 from "./AtelierSwitchAssuranceModalV2"
import AtelierRestiDepModalV2 from "./AtelierRestiDepModalV2"
import AtelierCheckRedirectV2 from "./AtelierCheckRedirectV2"
import { echapIgnoreParFiche } from "../../utilities/echapFiche"
import {
	BandeauIssueDepannage,
	ModalBasculeClient,
} from "./AtelierIssueDepannageV2"
import { fetchDepPaid } from "../../store/actions/atelierExtrasActions"
import { showToast, toastApiError } from "../../store/actions/toastActions"

/**
 * AtelierV2 — réécriture V2 (nouveau design) de Atelier.js.
 *
 * Migration bloc par bloc, cf. tasks.md à la racine du repo.
 * Phase 0 : scaffolding (chargement + layout + garde-fou). Les blocs métier
 * (infos de base, assurance, travaux, totaux…) sont ajoutés un par un ensuite.
 *
 * Conventions : function component + hooks, state local `form` immuable,
 * `generalStyles` inline, confirmations via CustomModal. Modèle : LocationV2.js.
 */

const Field = ({ label, children }) => (
	<div style={generalStyles.fieldRow}>
		<span style={generalStyles.label}>{label}</span>
		{children}
	</div>
)

// Toggler V2 (interrupteur on/off).
// Interrupteur on/off réutilisable (sans label). `color` = couleur à l'état actif.
const Switch = ({ on, onClick, disabled, title, color = COLORS.success }) => (
	<button
		type="button"
		role="switch"
		aria-checked={on}
		disabled={disabled}
		onClick={onClick}
		title={title}
		style={{
			width: 46,
			height: 26,
			borderRadius: 99,
			border: "none",
			padding: 0,
			position: "relative",
			cursor: disabled ? "default" : "pointer",
			backgroundColor: on ? color : COLORS.border,
			transition: "background-color 0.15s",
			flexShrink: 0,
		}}
	>
		<span
			style={{
				position: "absolute",
				top: 3,
				left: on ? 23 : 3,
				width: 20,
				height: 20,
				borderRadius: "50%",
				backgroundColor: "#fff",
				transition: "left 0.15s",
				boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
			}}
		/>
	</button>
)

const Toggler = ({ label, on, onClick, disabled }) => (
	<div style={generalStyles.fieldRow}>
		<span style={generalStyles.label}>{label}</span>
		<Switch on={on} onClick={onClick} disabled={disabled} />
	</div>
)

const etatLabel = (etat) => {
	const found = ATELIER_ETATS_CHOICES.find(([value]) => value === etat)
	return found ? found[1] : ""
}

// Couleur du badge d'état : un parcours sémantique le long du workflow atelier
// (brouillon → attente → travaux → facturation → paiement → clos) plutôt qu'un
// binaire clos/non-clos. L'accent bleu signale spécifiquement « travaux en cours ».
const etatBadgeStyle = (etat) => {
	switch (etat) {
		case ATELIER_ETAT_TRAVAUX_EN_COURS:
			return [COLORS.accent, COLORS.accentLight]
		case ATELIER_ETAT_DEVIS_ACCEPTE:
		case ATELIER_ETAT_TRAVAUX_TERMINES:
			return [COLORS.success, COLORS.successLight]
		case ATELIER_ETAT_EN_ATTENTE_CLIENT:
		case ATELIER_ETAT_A_RESTITUER:
		case ATELIER_ETAT_CONTROLE_AVANT_FACTURATION:
		case ATELIER_ETAT_OK_POUR_FACTURATION:
			return [COLORS.gold, COLORS.warningLight]
		case ATELIER_ETAT_DEVIS_REFUSE:
		case ATELIER_ETAT_EN_ATTENTE_PAIEMENT:
			return [COLORS.danger, COLORS.dangerLight]
		case ATELIER_ETAT_CLOS:
			return [COLORS.text, COLORS.border]
		default:
			// Brouillon (devis à faire / devis) : chip gris discret mais défini.
			return [COLORS.textMuted, COLORS.border]
	}
}

// Section fichiers V2 : affichage (images + PDF) via FileRenderer + ajout local.
// Les fichiers sont gérés hors `form`, contre redux (postAtelierFiles / deleteAtelierFile).
const FileSection = ({
	title,
	type,
	savedFiles,
	pending,
	onAdd,
	deleteFile,
	postDelete,
	resetDelete,
	canEdit,
	readOnly = false,
}) => {
	const inputRef = useRef(null)
	const count = savedFiles.length + pending.length
	const empty = count === 0
	return (
		<div>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 8,
					marginBottom: 10,
				}}
			>
				<span
					style={{
						fontSize: 13,
						fontWeight: 600,
						color: COLORS.text,
					}}
				>
					{title}
				</span>
				{count > 0 && (
					<span
						style={{
							fontSize: 11,
							fontWeight: 600,
							color: COLORS.textMuted,
							backgroundColor: COLORS.bg,
							border: `1px solid ${COLORS.border}`,
							borderRadius: 99,
							padding: "1px 8px",
						}}
					>
						{count}
					</span>
				)}
			</div>
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: 10,
					alignItems: "flex-start",
				}}
			>
				{savedFiles.length > 0 && (
					<FileRenderer
						files={savedFiles}
						deleteFile={deleteFile}
						postDelete={postDelete}
						resetDelete={resetDelete}
						canDelete={canEdit && !readOnly}
					/>
				)}
				{pending.map((p, i) => (
					<PendingFileCard
						key={`pending_${type}_${i}`}
						name={p.file.name}
					/>
				))}
				{canEdit && !readOnly && (
					<AddFileTile
						onClick={() =>
							inputRef.current && inputRef.current.click()
						}
					/>
				)}
				{empty && (!canEdit || readOnly) && (
					<span
						style={{
							fontSize: 12,
							color: COLORS.textLight,
							padding: "4px 0",
						}}
					>
						Aucun fichier.
					</span>
				)}
			</div>
			{canEdit && !readOnly && (
				<input
					ref={inputRef}
					type="file"
					multiple
					style={{ display: "none" }}
					onChange={(e) => onAdd(e, type)}
				/>
			)}
		</div>
	)
}

// Ligne de commentaire V2 (remplace visuellement le legacy AtelierCommentaire).
const CommentRow = ({ comment, onUpdate, onRemove, disabled }) => (
	<div
		style={{
			...generalStyles.obsItem,
			...(comment.marked
				? {
						backgroundColor: COLORS.warningLight,
						borderColor: COLORS.gold,
					}
				: {}),
		}}
	>
		<input
			type="text"
			style={generalStyles.obsInput}
			value={comment.texte}
			disabled={disabled}
			onChange={(e) => onUpdate(e.target.value, comment.id, "texte")}
		/>
		<button
			type="button"
			title={comment.marked ? "Ne plus surligner" : "Surligner"}
			style={generalStyles.iconBtn(
				comment.marked ? COLORS.gold : COLORS.textLight,
			)}
			disabled={disabled}
			onClick={() => onUpdate(!comment.marked, comment.id, "marked")}
		>
			<FontAwesomeIcon icon={faHighlighter} />
		</button>
		<button
			type="button"
			title="Supprimer le commentaire"
			style={generalStyles.iconBtn(COLORS.danger)}
			disabled={disabled}
			onClick={() => onRemove(comment.id)}
		>
			<FontAwesomeIcon icon={faTrash} />
		</button>
	</div>
)

// Modal « modifier prix vente » V2 (version form — pas de dispatch redux).
const ModifierPrixModal = ({ ligne, isAssurance, onApply, onClose }) => {
	const [menu, setMenu] = useState(isAssurance ? 0 : 1)
	const [pct, setPct] = useState("50")
	const [newPrix, setNewPrix] = useState("")
	// Champ du mode actif vide, ou collé non numérique (« 12,50 ») : la valeur
	// partait telle quelle dans la ligne et le save tombait en 500 au back
	// (`float("")`, NaN → null). « Modifier » reste grisé tant qu'elle est invalide.
	const valeur = menu === 0 ? pct : newPrix
	const nombreValeur = Number(valeur)
	// Participation : une part strictement entre 0 et 100 % (au-delà, la
	// ligne restante — assurance — passait en négatif).
	const valeurValide =
		valeur.trim() !== "" &&
		Number.isFinite(nombreValeur) &&
		(menu !== 0 || (nombreValeur > 0 && nombreValeur < 100))
	return (
		<CustomModal
			title={"Modifier le prix de vente"}
			onClose={onClose}
			showCloseButton={false}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: onClose,
				},
				{
					title: "Modifier",
					styleName: "primary",
					onClick: () => onApply(ligne, menu, pct, newPrix),
					disabled: !valeurValide,
				},
			]}
		>
			{/* Rangée de choix uniquement quand il y a vraiment 2 modes (assurance).
			    Sinon « Prix de vente » est le seul mode → bouton inutile, masqué. */}
			{isAssurance && (
				<div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
					<button
						type="button"
						style={
							menu === 0
								? generalStyles.btnPrimary
								: generalStyles.btnSecondary
						}
						onClick={() => setMenu(0)}
					>
						Dupliquer (participation)
					</button>
					<button
						type="button"
						style={
							menu === 1
								? generalStyles.btnPrimary
								: generalStyles.btnSecondary
						}
						onClick={() => setMenu(1)}
					>
						Prix de vente
					</button>
				</div>
			)}
			{menu === 0 ? (
				<Field label={"Participation client (%)"}>
					<input
						style={generalStyles.input}
						value={pct}
						onChange={(e) => setPct(e.target.value)}
						onKeyDown={(e) => typeNumber(e)}
					/>
				</Field>
			) : (
				<Field label={"Nouveau prix de vente"}>
					<input
						style={generalStyles.input}
						value={newPrix}
						placeholder={`${ligne.prixVente}`}
						onChange={(e) => setNewPrix(e.target.value)}
						onKeyDown={(e) => typeNumber(e)}
					/>
				</Field>
			)}
		</CustomModal>
	)
}

// Select assurance V2 (remplace le legacy AssuranceSelect basé sur des classes CSS).
const AssuranceSelectV2 = ({
	label,
	value,
	assurances,
	onChange,
	disabled,
	selectRef,
	nextRef,
	prevRef,
}) => (
	<Field label={label}>
		<SelectV2
			ref={selectRef}
			nextRef={nextRef}
			prevRef={prevRef}
			value={value}
			style={generalStyles.select}
			disabled={disabled}
			onChange={(e) => onChange(parseInt(e.target.value))}
		>
			<option value={0}>-</option>
			{assurances.map((ass) => (
				<option key={`ass_${ass.id}`} value={ass.id}>
					{ass.label}
				</option>
			))}
		</SelectV2>
	</Field>
)

/**
 * Une section de travaux (Main d'œuvre / Fournitures / Autres / Suppléments).
 *
 * Extrait en composant car le drag/drop (useSortableLignes) est un hook : il doit
 * être appelé une fois par section, ce qui est impossible dans un `.map`. La
 * config de colonnes est décidée ici, une fois pour la section, et partagée par
 * l'en-tête et toutes les lignes (alignement garanti).
 */
const TravauxSection = ({
	section,
	lignes,
	atelier,
	isSVP,
	canEdit,
	updateAtelierLignes,
	replaceLigne,
	removeAtelierLignes,
	onModifierPrix,
	onAddLigne,
	onReorder,
	onSousTraitant,
	onInventaire,
}) => {
	const { isResponsableAtelier } = useGroups()
	const { canSeeAdmin, canSeePrixAchat } = useAtelierPermissions()
	// Index de la ligne à focuser après ajout (clic « Ajouter » → saisie clavier).
	const [autoFocusIdx, setAutoFocusIdx] = useState(null)

	const colConfig = useMemo(
		() =>
			buildColConfig({
				numero: lignes.some((l) => l.articleVirtuel > 0),
				valide: isResponsableAtelier,
				prixAchat: canSeePrixAchat,
				prixVente: !isSVP,
				rabais: !isSVP,
				payePar: atelier.isAssurance && !isSVP,
				// Réserver la piste « Payé » dès que l'utilisateur peut la voir,
				// même si aucune ligne de CETTE section n'affiche de case : sinon
				// la colonne apparaît dans certaines sections (Fournitures/Autres,
				// ou Main d'œuvre/Suppléments avec sous-traitant) et pas d'autres,
				// désalignant les grilles entre types de lignes. La case elle-même
				// reste conditionnée par `showPaye` dans AtelierLigneRow.
				paye: canSeeAdmin,
				modifierPrix: true,
			}),
		[
			lignes,
			isResponsableAtelier,
			canSeePrixAchat,
			isSVP,
			atelier.isAssurance,
			canSeeAdmin,
		],
	)

	const ligneIds = useMemo(() => lignes.map((l) => l.id), [lignes])
	const { setNode, getHandleProps, getRowStyle, draggingId } =
		useSortableLignes(
			ligneIds,
			(from, to) => onReorder(section.type, from, to),
			{ disabled: !canEdit },
		)

	return (
		<div style={generalStyles.mt18}>
			<div
				style={{
					fontSize: 12,
					fontWeight: 600,
					color: COLORS.text,
					marginBottom: 8,
				}}
			>
				{section.title}
			</div>
			{lignes.length > 0 && <AtelierLigneHeader colConfig={colConfig} />}
			{lignes.map((ligne, i) => (
				<AtelierLigneRow
					key={`al_${ligne.id}`}
					atelierLigne={ligne}
					atelier={atelier}
					colConfig={colConfig}
					isSVP={isSVP}
					disableLigne={!canEdit}
					updateAtelierLignes={updateAtelierLignes}
					updateLigneFull={replaceLigne}
					removeAtelierLignes={removeAtelierLignes}
					onModifierPrix={onModifierPrix}
					autoFocus={i === autoFocusIdx}
					onAutoFocused={() => setAutoFocusIdx(null)}
					setNode={setNode}
					getHandleProps={getHandleProps}
					getRowStyle={getRowStyle}
					isDragging={draggingId === ligne.id}
				/>
			))}
			{canEdit && (
				<div style={{ display: "flex", gap: 8, marginTop: 10 }}>
					<button
						type="button"
						style={generalStyles.addBtn}
						onClick={() => {
							onAddLigne(section.type)
							setAutoFocusIdx(lignes.length)
						}}
					>
						<FontAwesomeIcon icon={faPlus} />
						Ajouter une ligne
					</button>
					{section.type === ATELIER_LIGNE_TYPE_MAIN_OEUVRE ? (
						<button
							type="button"
							title="Sous-traitant"
							style={generalStyles.iconBtn(COLORS.text)}
							onClick={onSousTraitant}
						>
							<FontAwesomeIcon icon={faHandshake} />
						</button>
					) : (
						<button
							type="button"
							title="Inventaire"
							style={generalStyles.iconBtn(COLORS.text)}
							onClick={() => onInventaire(section.type)}
						>
							<FontAwesomeIcon icon={faSitemap} />
						</button>
					)}
				</div>
			)}
		</div>
	)
}

// GE-69 (revue, D4 Jordan 12.10) : une fiche de RÉPARATION (POI Atelier) en
// client de passage N'EST PAS une vente rapide — vrai véhicule à réparer :
// kms affichés et exigés, rabais / marge visibles (location : seulement
// après « Associer un client », J1). Les
// fiches fournitures (GE-67) et les ventes rapides ne changent pas.
// Module-level : seuil rules-of-hooks du plugin CRA 3.
const estFicheReparation = (atelier) =>
	!!atelier.issue_depannage && atelier.issue_depannage.type === "reparation"
const estVenteRapide = (form) =>
	form !== null &&
	form.entite.type === ENTITE_TYPE_CLIENT_PASSAGE &&
	!estFicheReparation(form.atelier)
// « Associer un client » dans la carte client (Y7) : toute fiche en client
// de passage sauf celle issue d'un dépannage (bouton dans son bandeau).
const peutAssocierClientCarte = (form, verrouillee) =>
	form !== null &&
	form.entite.type === ENTITE_TYPE_CLIENT_PASSAGE &&
	!form.atelier.issue_depannage &&
	Number.isInteger(form.atelier.id) &&
	!verrouillee

// Atelier « liable » à une location : persisté et pas encore de location
// rattachée. On peut alors créer une location (payante) ou un prêt, avec ou
// sans couverture assurance.
const atelierLocationLinkable = (atelier) =>
	Number.isInteger(atelier.id) && atelier.location === 0

// Couverture location assurance complète → on pré-remplit les champs associés
// à la création de la location. Défini au niveau module à dessein — une longue
// chaîne `&&` dans le composant déclenche un faux positif
// react-hooks/rules-of-hooks (vieux plugin CRA3).
const atelierCouvertureLocationComplete = (atelier) =>
	atelier.isCouvertLocation === 1 &&
	atelier.assuranceLocation > 0 &&
	atelier.nbJoursLocation > 0 &&
	atelier.tarifJoursLocation > 0

// Devis à générer : fiche non-SVP déjà avancée (au-delà de l'étape Devis) et
// sans fichier devis enregistré. Défini au niveau module (même raison que
// atelierCouvertureLocationComplete : éviter une longue chaîne && dans le composant).
const atelierDevisAGenerer = (atelier, canEdit, nbDevisFiles) =>
	canEdit &&
	!atelier.svp &&
	atelier.etat > ATELIER_ETAT_DEVIS &&
	nbDevisFiles === 0

export default function AtelierV2() {
	const { id } = useParams()
	const location = useLocation()
	const dispatch = useDispatch()
	const history = useHistory()
	const permissions = useAtelierPermissions()
	const { hasRight } = useRights()
	const { isAdmin } = useGroups()
	const mdpFacture = useMoyenPaiementFacture()

	const atelierInfo = useSelector((state) => state.atelierInfo)
	const groupes = useSelector((state) => state.navInfo.login.groups)
	// Jordan 19.10 : une règle de modification des transactions pour les 3
	// fiches (utilities/transactionsV2) ; responsable du module, fiche
	// enregistrée (Jordan 30.10).
	const ficheCompta = {
		module: "atelier",
		etat: (atelierInfo.atelier || {}).etat,
	}
	const niveau = niveauTransactions({
		isBoss: permissions.isBoss,
		isAdmin,
		groupes,
		...ficheCompta,
	})
	const employes = useSelector((state) => state.masterReducer.employes)
	const masterEntite = useSelector(
		(state) => state.masterReducer.masterEntite,
	)
	const assurances = useSelector((state) => state.autreInfo.assurances)
	// Historique des e-mails : slice dédié depuis GE-25 (plus dans atelierInfo).
	const emails = useSelector((state) => state.emailInfo.emails)
	const moyenPaiements = useSelector(
		(state) => state.autreInfo.moyenPaiements,
	)
	const token = useSelector((state) => state.navInfo.login.token)
	const restiDep = useSelector((state) => state.atelierExtrasInfo)
	const appels = useSelector((state) => state.depInfo.appels)
	const accessModules = useSelector((state) => state.accessInfo.modules)
	const fournisseurs = useSelector((state) => state.autreInfo.fournisseurs)
	const experts = useSelector((state) => state.autreInfo.experts)
	const clientPassage = useSelector((state) => state.autreInfo.clientPassage)
	const atelierInventaire = useSelector((state) => state.atelierInventaire)
	// Résultats de la dernière recherche : destination d'Échap (tableau s'il y
	// en a, formulaire sinon — règle commune aux 3 fiches).
	const atelierFiches = useSelector(
		(state) => state.atelierSearchInfo.atelierFiches,
	)
	const { listeAtelierModeles, fetchAtelierModeles: fetchModelesStatus } =
		useSelector((state) => state.atelierModeleInfo)
	const tarif = useTarif()
	const refExpert = useRef(null)
	const refAfterExpert = useRef(null)
	// Chaîne de focus de la carte « Informations fiche » (Entrée enchaîne jusqu'à
	// « Kms prochains travaux »).
	const refDateFiche = useRef(null)
	const refEtat = useRef(null)
	const refMecanicien = useRef(null)
	const refKms = useRef(null)
	const refDateProchain = useRef(null)
	const refKmsProchain = useRef(null)
	// Chaîne de focus de la section Assurance (Entrée enchaîne jusqu'à Remarques).
	const refAssurance = useRef(null)
	const refAudatex = useRef(null)
	const refFranchise = useRef(null)
	const refRabaisFranchise = useRef(null)
	const refCouverture = useRef(null)
	const refAssuranceLocation = useRef(null)
	const refRefLocation = useRef(null)
	const refNbJours = useRef(null)
	const refTarifJours = useRef(null)
	const refRemarques = useRef(null)
	const {
		atelier,
		entite,
		atelierLignes,
		atelierCommentaires,
		// Heures de travail : elles vivent dans redux (pas dans `form`) mais
		// partent dans le payload de save → elles comptent dans le dirty-check.
		heures,
		fetchAtelier: fetchAtelierStatus,
		fetchClient: fetchClientStatus,
		fetchAtelierLignes: fetchAtelierLignesStatus,
	} = atelierInfo

	// État local consolidé de la fiche (peuplé une fois les fetchs terminés).
	const [form, setForm] = useState(null)
	const [modalSwitchAssurance, setModalSwitchAssurance] = useState(false)
	const [switchAssuranceSel, setSwitchAssuranceSel] = useState(0)
	// Modals Travaux (Phase 4.4)
	const [sousTraitantsModal, setSousTraitantsModal] = useState(false)
	const [inventaireModal, setInventaireModal] = useState(false)
	const [inventaireType, setInventaireType] = useState(
		ATELIER_LIGNE_TYPE_FOURNITURE,
	)
	const [modeleModal, setModeleModal] = useState(false)
	const [modifierPrixLigne, setModifierPrixLigne] = useState(null)
	const [addTransactionModal, setAddTransactionModal] = useState(false)
	const [showModalEmail, setShowModalEmail] = useState(false)
	const [modalSave, setModalSave] = useState(false)
	// Popup d'impression : choix du modèle PDF (diagnostique / fiche de travail / fiche).
	const [printModal, setPrintModal] = useState(false)
	// Popup : choix Location (payante) / Prêt (gratuit) à la création d'une loc.
	const [modalCreerLocation, setModalCreerLocation] = useState(false)
	// Popup : société sans « Représenté par » à la génération du doc de restitution.
	const [representeParModal, setRepresenteParModal] = useState(false)
	const [saveAtelierModal, setSaveAtelierModal] = useState(false)
	const [saveNext, setSaveNext] = useState(false)
	// Génération d'un devis manquant (fiche déjà au-delà de l'état Devis) :
	// ouvre SaveAtelierV2 sur l'étape devis sans changer l'état.
	const [devisOnly, setDevisOnly] = useState(false)
	const [factureOnly, setFactureOnly] = useState(false)
	const [facturationModal, setFacturationModal] = useState(false)
	const [cloreModal, setCloreModal] = useState(false)
	// Liste des champs manquants bloquant la clôture (vide = modal fermé).
	const [cloreManquants, setCloreManquants] = useState([])
	const [modalRestiDep, setModalRestiDep] = useState(false)
	const [redirectLoc, setRedirectLoc] = useState({
		show: false,
		state: 0,
		error: false,
	})
	// Fichiers en attente d'upload (gérés hors `form`, comme le legacy).
	const [pendingFiles, setPendingFiles] = useState([])

	// Garde-fou "modifications non sauvegardées".
	const { setDirty, setClean, QuitGuard } = useQuitGuard()
	const savedFormRef = useRef(null)
	// Baseline des heures (redux, hors `form` — cf. destructuration plus haut).
	const savedHeuresRef = useRef(null)
	// `form` toujours à jour, lisible depuis un callback asynchrone (le closure
	// d'un `.then` de save porte le form d'AVANT l'aller-retour réseau).
	const formRef = useRef(null)
	useEffect(() => {
		formRef.current = form
	})
	const loadedRef = useRef(false)
	// Vrai quand on initialise une NOUVELLE fiche (arrivée from:"clients" + extraData)
	// au lieu de charger une fiche existante : adapte les gardes de snapshot/lock.
	const creatingRef = useRef(false)
	// Incrémenté pour forcer un rechargement complet de la fiche (ex. après une
	// prise de main : on doit repartir des données serveur à jour).
	const [reloadCounter, setReloadCounter] = useState(0)
	// GE-67 : modal « Associer un client » (fiche issue d'un dépannage).
	const [bascule, setBascule] = useState(false)

	// Les lignes sont fetchées séparément de l'atelier. On note qu'elles ont été
	// DEMANDÉES pour ce chargement ; le snapshot du form attendra leur arrivée
	// (cf. effet d'init) pour ne pas figer une liste vide (bug « 1 fois sur 2 »).
	const lignesRequestedRef = useRef(false)

	// --- Chargement initial (Phase 0) -------------------------------------
	useEffect(() => {
		lignesRequestedRef.current = false
		// Réinitialise pour permettre un nouveau snapshot quand `:id` change
		// (feuilletage Page Up/Down entre fiches sans démontage du composant).
		loadedRef.current = false
		creatingRef.current = false
		setForm(null)
		// Le dirty appartenait à la fiche PRÉCÉDENTE : sans ces remises à zéro,
		// il survivait pendant tout le chargement de la nouvelle (le
		// dirty-check ne dit rien tant que `form` est null) et les fichiers en
		// attente d'upload de la fiche A pouvaient être attachés à la fiche B.
		savedFormRef.current = null
		savedHeuresRef.current = null
		setPendingFiles([])
		setClean()
		// Création d'une nouvelle fiche : arrivée depuis l'écran client (goToNewFiche
		// / newFicheAtelier) avec from:"clients" + extraData. On ne charge PAS de fiche
		// existante ; on amorce une fiche vierge (getBaseAtelier) pré-remplie depuis
		// extraData (entité + véhicule + adresse + état). Cf. legacy loadEntite.
		// Création « client de passage » (vente rapide) depuis le menu : fiche
		// vierge associée à l'entité client de passage. Son adresse et son véhicule
		// sont des FK valides pointant sur des enregistrements « vides » → on peut
		// faire la fiche sans renseigner de client. Cf. legacy Atelier.js from:"home".
		if (location.from === "client-passage" && clientPassage.id) {
			creatingRef.current = true
			dispatch(fetchAtelierReset()).then(() => {
				dispatch(fetchAtelierEntite(clientPassage.id)).then(() => {
					const a = { ...getBaseAtelier(), entite: clientPassage.id }
					a.vehicule = clientPassage.vehicules[0]
						? clientPassage.vehicules[0].id
						: null
					a.adresse = clientPassage.adresses[0]
						? clientPassage.adresses[0].id
						: null
					a.etat = ATELIER_ETAT_TRAVAUX_EN_COURS
					dispatch({ type: "SET_ATELIER", value: a })
					lignesRequestedRef.current = true
				})
			})
			return
		}
		if (location.from === "clients" && location.extraData) {
			creatingRef.current = true
			const ex = location.extraData
			dispatch(fetchAtelierReset()).then(() => {
				dispatch(fetchAtelierEntite(ex.entiteId)).then((entite) => {
					const a = { ...getBaseAtelier(), entite: ex.entiteId }
					a.vehicule = ex.vehiculeId
						? ex.vehiculeId
						: entite.vehicules && entite.vehicules.length === 1
							? entite.vehicules[0].id
							: null
					a.adresse = ex.adresseId
						? ex.adresseId
						: entite.adresses && entite.adresses.length === 1
							? entite.adresses[0].id
							: null
					if (ex.etat >= -1) a.etat = ex.etat
					dispatch({ type: "SET_ATELIER", value: a })
					// Fiche neuve : lignes vides (reset), aucun fetch de lignes.
					lignesRequestedRef.current = true
				})
			})
			return
		}
		dispatch(fetchAtelierReset()).then(() => {
			dispatch(fetchAtelier(id)).then((action) => {
				if (action === undefined) {
					history.push("/home")
					return
				}
				const loadedAtelier = action.payload.atelier
				if (loadedAtelier.entite) {
					dispatch(fetchAtelierEntite(loadedAtelier.entite))
				} else {
					dispatch(fetchClient(loadedAtelier.client))
					dispatch(fetchClientVehicules({ id: loadedAtelier.client }))
				}
				dispatch(fetchAtelierLignes(id))
				lignesRequestedRef.current = true
				dispatch(fetchAtelierCommentaires(id))
				dispatch(fetchEmails(id, EMAIL_DOMAINE_ATELIER))
			})
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, reloadCounter])

	// Une fois la fiche chargée en redux, on en fait un snapshot local éditable.
	useEffect(() => {
		if (loadedRef.current) return
		// En création (from:"clients"), l'atelier a `id === null` : on ne bloque pas
		// sur l'id, mais on attend que SET_ATELIER ait posé l'entité pré-remplie ET
		// que cette entité soit chargée.
		const isCreating = creatingRef.current
		if (
			!isCreating &&
			(atelier.id === null || String(atelier.id) !== String(id))
		)
			return
		// Attendre que l'entité (client + véhicules + adresses) soit chargée pour
		// CET atelier : sinon, sur F5 (redux à froid), le snapshot figerait une
		// entité vide car fetchAtelierEntite/fetchClient se résout APRÈS fetchAtelier
		// (la garde loadedRef empêche ensuite toute resynchro). `RESET_ATELIER`
		// vide l'entité avant chaque chargement, donc id !== null = chargée pour
		// cet atelier.
		const entitePrete = isCreating
			? atelier.entite && entite.id === atelier.entite
			: entite.id !== null &&
				(!atelier.entite || entite.id === atelier.entite)
		if (!entitePrete) return
		// Attendre que les lignes aient été demandées ET que leur fetch soit
		// terminé : sinon le snapshot fige un `atelierLignes` vide quand l'entité
		// se résout avant les lignes (course → bug « 1 fois sur 2 »).
		if (!lignesRequestedRef.current || fetchAtelierLignesStatus.loading)
			return
		const loaded = {
			atelier: {
				...atelier,
				transactionsv2: (atelier.transactionsv2 || []).map((t) => ({
					...t,
					quittance: normalizePdf(t.quittance),
					facture: normalizePdf(t.facture),
				})),
			},
			entite: { ...entite },
			atelierLignes: atelierLignes.map((l) => ({ ...l })),
			atelierCommentaires: atelierCommentaires.map((c) => ({ ...c })),
			// Données de paiement sous-traitants (payeLe/file/id) ; les totaux
			// sont recalculés depuis les lignes (cf. sousTraitantsMerged).
			sousTraitants: (atelierInfo.sousTraitants || []).map((s) => ({
				...s,
			})),
		}
		setForm(loaded)
		savedFormRef.current = JSON.stringify(loaded)
		savedHeuresRef.current = JSON.stringify(heures || [])
		loadedRef.current = true
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		atelier,
		entite,
		atelierLignes,
		atelierCommentaires,
		id,
		fetchAtelierLignesStatus.loading,
	])

	// Écart au dernier état sauvegardé. Les heures de travail comptent : elles
	// sont saisies dans redux (`atelierInfo.heures`) et pas dans `form`, mais
	// elles partent dans le payload de save — invisibles du dirty-check, elles
	// se perdaient sans la moindre popup. Une seule fonction pour tous les
	// lecteurs (garde-fou, bouton Imprimer, e-mail, prise de main), qui
	// faisaient chacun leur propre comparaison.
	const ficheModifiee = () => {
		if (form === null || savedFormRef.current === null) return false
		if (JSON.stringify(form) !== savedFormRef.current) return true
		return (
			savedHeuresRef.current !== null &&
			JSON.stringify(heures || []) !== savedHeuresRef.current
		)
	}
	// Travail non enregistré au sens « on perd quelque chose en partant » : la
	// fiche modifiée, plus les fichiers sélectionnés et pas encore uploadés.
	const travailNonEnregistre = () =>
		ficheModifiee() || pendingFiles.length > 0

	// Dirty-check : canQuit suit cet écart.
	useEffect(() => {
		if (form === null || savedFormRef.current === null) return
		if (travailNonEnregistre()) setDirty()
		else setClean()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form, heures, pendingFiles, setClean, setDirty])

	// --- Verrou exclusif de la fiche --------------------------------------
	// Toute la mécanique (open/heartbeat/beacon/close, demande de prise de
	// main, modals) vit dans `useFicheVerrou`, partagé avec les fiches
	// dépannage et location. Ici on ne garde que le branchement : quelle
	// fiche, et quoi faire quand on (re)prend la main. Déclaré APRÈS le
	// dirty-check : le hook a besoin de `travailNonEnregistre()` pour prévenir
	// le détenteur qu'il perdrait sa saisie en cédant la main.
	const verrou = useFicheVerrou("ate", id, {
		// Main obtenue : on était en lecture seule, nos données peuvent être
		// périmées → rechargement complet.
		onMainObtenue: () => setReloadCounter((c) => c + 1),
		travailNonEnregistre: travailNonEnregistre(),
	})

	// « Un modal est à l'écran » : neutralise Échap ET le feuilletage (un
	// PageDown sous un modal de save posterait la fiche suivante).
	// Tout modal rendu par la fiche : Échap (retour aux résultats) et le
	// feuilletage Page Up/Down sont suspendus tant qu'il est ouvert.
	const anyModalOpen =
		modalSwitchAssurance ||
		sousTraitantsModal ||
		inventaireModal ||
		modeleModal ||
		modifierPrixLigne !== null ||
		addTransactionModal ||
		showModalEmail ||
		modalSave ||
		printModal ||
		modalCreerLocation ||
		representeParModal ||
		saveAtelierModal ||
		facturationModal ||
		cloreModal ||
		cloreManquants.length > 0 ||
		redirectLoc.show ||
		verrou.modalOuvert ||
		modalRestiDep

	// Feuilletage clavier Page Up/Down dans la liste figée par la page-liste
	// (résultats de recherche OU /atelier/etat — l'ancien mécanisme ne
	// connaissait que la recherche, et ne nettoyait jamais son `from`).
	// Suspendu modal ouvert : l'ancien hook atelier ne l'était pas.
	useFeuilletage("ate", "/atelier/fiche", anyModalOpen)

	// --- Helpers d'édition (state local immuable) -------------------------
	const updateAtelier = (field, value) => {
		setForm((f) => ({ ...f, atelier: { ...f.atelier, [field]: value } }))
	}

	// --- Lignes d'atelier (state local immuable) --------------------------
	const updateAtelierLignes = (value, field, id) => {
		setForm((f) => ({
			...f,
			atelierLignes: f.atelierLignes.map((al) => {
				if (al.id !== id) return al
				const next = { ...al }
				if (
					next.articleVirtuel > 0 &&
					field === "quantite" &&
					parseFloat(value) > next.quantite_max
				) {
					next.quantite = next.quantite_max
				} else {
					next[field] = value
				}
				return next
			}),
		}))
	}
	// Remplace une ligne par son id (la ligne ignore son index global).
	const replaceLigne = (ligne) => {
		setForm((f) => ({
			...f,
			atelierLignes: f.atelierLignes.map((al) =>
				al.id === ligne.id ? ligne : al,
			),
		}))
	}
	// Réordonne au sein d'un type (= une section). `from`/`to` sont des index
	// locaux à la section ; `to` est l'index d'insertion après retrait (cf. le
	// hook useSortableLignes). On permute les lignes du type EN PLACE, sans
	// toucher aux positions des lignes des autres types dans le tableau global.
	const reorderLignes = (type, from, to) => {
		setForm((f) => {
			const section = f.atelierLignes.filter((l) => l.type === type)
			if (from < 0 || from >= section.length) return f
			const reordered = [...section]
			const [moved] = reordered.splice(from, 1)
			reordered.splice(
				Math.max(0, Math.min(to, reordered.length)),
				0,
				moved,
			)
			let k = 0
			const atelierLignes = f.atelierLignes.map((l) =>
				l.type === type ? reordered[k++] : l,
			)
			return { ...f, atelierLignes }
		})
	}
	const removeAtelierLignes = (al) => {
		setForm((f) => {
			let lignes = [...f.atelierLignes]
			// cas #1 : ligne dupliquée → on restaure la ligne source + on retire la dupliquée
			if (al.dupliquer_from !== null) {
				lignes = lignes
					.map((l) =>
						l.id === al.dupliquer_from
							? {
									...l,
									prixVente: l.prixVenteFirstValue,
									prixVenteModifie: false,
								}
							: l,
					)
					.filter((l) => l.id !== al.id)
			}
			// cas #2 : ligne avec prix modifié ayant une dupliquée → on retire les deux
			else if (al.prixVenteModifie) {
				const duplique = lignes.find((l) => l.dupliquer_from === al.id)
				if (duplique) {
					lignes = lignes.filter(
						(l) => l.id !== al.id && l.id !== duplique.id,
					)
				} else {
					lignes = lignes.filter((l) => l.id !== al.id)
				}
			}
			// cas #3 : suppression simple
			else {
				lignes = lignes.filter((l) => l.id !== al.id)
			}
			return { ...f, atelierLignes: lignes }
		})
	}
	const getPrixVenteRabaisMainOeuvre = (
		type,
		payePar = null,
		assuranceOverride = null,
	) => {
		if (type !== ATELIER_LIGNE_TYPE_MAIN_OEUVRE)
			return { prixVente: 0, rabais: 0 }
		const a = form.atelier
		const ent = form.entite
		const assId =
			assuranceOverride !== null ? assuranceOverride : a.assurance
		let prixVente = 0
		let rabais = 0
		const pp =
			payePar !== null
				? payePar
				: a.isAssurance
					? PAYE_PAR_ASSURANCE
					: PAYE_PAR_CLIENT
		if (pp === PAYE_PAR_ASSURANCE) {
			prixVente = tarif.prixHoraireAssurance
			if (assId !== 0) {
				const ass = assurances.find((x) => x.id === assId)
				if (
					ass &&
					ass.extra_data.prix_vente_unitaire_mo &&
					ass.extra_data.prix_vente_unitaire_mo !== ""
				) {
					rabais = parseFloat(ass.extra_data.prix_vente_unitaire_mo)
				}
			}
		} else {
			if (ent.type === ENTITE_TYPE_SOCIETE)
				prixVente = tarif.prixHoraireSociete
			else if (
				ent.type === ENTITE_TYPE_PERSONNE_PHYSIQUE ||
				ent.type === ENTITE_TYPE_CLIENT_PASSAGE
			)
				prixVente = tarif.prixHoraire
			if (
				ent.extra_data &&
				ent.extra_data.prix_vente_unitaire_mo &&
				ent.extra_data.prix_vente_unitaire_mo !== ""
			) {
				rabais = parseFloat(ent.extra_data.prix_vente_unitaire_mo)
			}
		}
		return { prixVente, rabais }
	}
	const addAtelierLignes = (type) => {
		const t = parseInt(type)
		const { prixVente, rabais } = getPrixVenteRabaisMainOeuvre(t)
		const al = {
			...getBaseAtelierLigne(t),
			prixVente,
			prixAchat:
				t === ATELIER_LIGNE_TYPE_MAIN_OEUVRE ? tarif.coutHoraire : 0,
			payePar: form.atelier.isAssurance
				? PAYE_PAR_ASSURANCE
				: PAYE_PAR_CLIENT,
			type: t,
			rabais,
		}
		setForm((f) => ({ ...f, atelierLignes: [...f.atelierLignes, al] }))
	}

	const appendLigne = (al) =>
		setForm((f) => ({ ...f, atelierLignes: [...f.atelierLignes, al] }))
	const appendLignes = (als) =>
		setForm((f) => ({ ...f, atelierLignes: [...f.atelierLignes, ...als] }))

	// Ajout d'une ligne main d'œuvre sous-traitée (depuis le modal sous-traitants).
	const addAtelierLigneSousTraitant = (sousTraitantId) => {
		const a = form.atelier
		let payePar = PAYE_PAR_CLIENT
		let rabais = 0
		let prixVente = 0
		if (a.isAssurance) {
			payePar = PAYE_PAR_ASSURANCE
			prixVente = tarif.prixHoraireAssurance
			const ass = assurances.find((x) => x.id === a.assurance)
			if (
				ass &&
				ass.extra_data.prix_vente_unitaire_mo &&
				ass.extra_data.prix_vente_unitaire_mo !== ""
			) {
				rabais = parseFloat(ass.extra_data.prix_vente_unitaire_mo)
			}
		}
		const st = fournisseurs.find((x) => x.id === sousTraitantId)
		appendLigne({
			...getBaseAtelierLigne(ATELIER_LIGNE_TYPE_MAIN_OEUVRE),
			id: Math.random(),
			prixVente,
			prixAchat: st ? st.prix_achat : 0,
			payePar,
			sousTraitant: sousTraitantId,
			rabais,
		})
		setSousTraitantsModal(false)
	}

	// Ligne "autre/fourniture" sous-traitée (depuis le modal inventaire).
	const addAtelierLigneSousTraitantAutre = (sousTraitantId) => {
		const payePar = form.atelier.isAssurance
			? PAYE_PAR_ASSURANCE
			: PAYE_PAR_CLIENT
		appendLigne({
			...getBaseAtelierLigne(inventaireType),
			id: Math.random(),
			payePar,
			sousTraitant: sousTraitantId,
			isAchHT: inventaireType !== ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
		})
		setInventaireModal(false)
	}

	// Ligne fourniture (depuis le modal inventaire). Ajoute la fourniture au
	// référentiel redux si nouvelle.
	const addAtelierLigneFourniture = (fourniture, sousTraitantId = 0) => {
		const payePar = form.atelier.isAssurance
			? PAYE_PAR_ASSURANCE
			: PAYE_PAR_CLIENT
		if (
			!atelierInfo.fournitures.find((four) => four.id === fourniture.id)
		) {
			dispatch({ type: "ADD_FOURNITURE", value: fourniture })
		}
		appendLigne({
			...getBaseAtelierLigne(inventaireType),
			id: Math.random(),
			label: fourniture.label,
			payePar,
			fourniture: fourniture.id,
			sousTraitant: sousTraitantId,
		})
		setInventaireModal(false)
	}

	// Ligne(s) inventaire (article unique ou liste d'articles virtuels).
	// « Payé » (fourniturePaid) est posé par le back au débit du stock,
	// pas à l'ajout : la ligne part avec la valeur par défaut (false).
	const addAtelierLigneInventaire = (article) => {
		const type = inventaireType
		const payePar = form.atelier.isAssurance
			? PAYE_PAR_ASSURANCE
			: PAYE_PAR_CLIENT
		if (Array.isArray(article)) {
			appendLignes(
				article.map((art) => ({
					...getBaseAtelierLigne(type),
					id: Math.random(),
					label: art.label,
					quantite: art.quantite_recue - art.quantite_utilisee,
					quantite_max: art.quantite_recue - art.quantite_utilisee,
					prixVente: art.prix_vente_ht,
					prixAchat: art.prix_achat_ht,
					articleVirtuelNumero: art.numero ? art.numero : "",
					payePar,
					articleVirtuel: art.id,
				})),
			)
		} else {
			appendLigne({
				...getBaseAtelierLigne(type),
				id: Math.random(),
				label: article.nom,
				articleVirtuelNumero: article.numero ? article.numero : "",
				prixVente: article.prixVente,
				payePar,
				// Le flag HT/TTC du prix de vente vient de l'article.
				isHT: !!article.isPrixVenteHT,
				article: article.id,
				isAchHT: false,
			})
		}
		setInventaireModal(false)
	}

	// Application d'un modèle (ajoute ses lignes + commentaires au form).
	const addModeleToAtelier = (modele) => {
		const payePar = form.atelier.isAssurance
			? PAYE_PAR_ASSURANCE
			: PAYE_PAR_CLIENT
		const lignes = modele.atelierLigneModele.map((al) => {
			const next = {
				...al,
				id: Math.random(),
				payePar,
				rabais: 0,
				sousTraitant: 0,
				fourniture: 0,
				rabaisIsFlat: true,
				isForfait: modele.isForfait,
				articleVirtuel: 0,
				valide: false,
				fourniturePaid: false,
				modele: modele.id,
			}
			if (
				!modele.isForfait &&
				next.type === ATELIER_LIGNE_TYPE_MAIN_OEUVRE
			) {
				const { prixVente, rabais } = getPrixVenteRabaisMainOeuvre(
					ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
				)
				next.prixVente = prixVente
				next.rabais = rabais
			}
			return next
		})
		const commentaires = modele.atelierCommentaireModele.map((ac) => ({
			...ac,
			id: Math.random(),
		}))
		setForm((f) => ({
			...f,
			atelierLignes: [...f.atelierLignes, ...lignes],
			atelierCommentaires: [...f.atelierCommentaires, ...commentaires],
		}))
		setModeleModal(false)
	}

	const openInventaireModal = (type) => {
		setInventaireType(type)
		setInventaireModal(true)
	}

	// --- Sauvegarde (Phase 12) --------------------------------------------
	// Construit l'objet atelier envoyé (avec total/totalAchat/rabais calculés).
	// Pas d'auto-clôture : le passage à l'état CLOS se fait uniquement via le
	// bouton « Clore » (cf. confirmClore), après validation des champs.
	const buildAtelierForSave = () => {
		const a = {
			...form.atelier,
			total: totaux
				? HTtoTTC(totaux.sousTotHT, form.atelier.tva)
				: form.atelier.total,
			totalAchat: totaux ? totaux.totAchat : form.atelier.totalAchat,
			rabais: totaux ? totaux.rabaisHT : form.atelier.rabais,
		}
		return a
	}
	const getAtelierJson = (atelierForSave) => ({
		client: atelierInfo.client,
		clientVehicules: atelierInfo.clientVehicules,
		atelier: atelierForSave,
		atelierLignes: form.atelierLignes,
		atelierCommentaires: form.atelierCommentaires,
		sousTraitants: sousTraitantsMerged,
		heures: atelierInfo.heures,
		// Garde-fou verrou : le back refuse le save (409) si cette session ne détient
		// plus la fiche (prise de main pendant l'édition).
		opener: getOpenerId(),
	})
	// feedback=true : save « nu » (bouton Sauvegarder). Comme il n'y a pas de
	// modale pour afficher le résultat, on toaste l'erreur (postAtelier non
	// silencieux) ET le succès. Les autres appelants (SaveAtelierV2, transitions)
	// gardent feedback=false : ils affichent le résultat dans leur propre modale.
	// `signaux` : clés posées à la racine du JSON, pour CE save seulement
	// (jamais reportées dans le form), ex. GE-77 remettre_degats_a_zero.
	const save = (
		callback = null,
		atelierOverride = null,
		{ feedback = false, signaux = {} } = {},
	) => {
		const atelierForSave = atelierOverride || buildAtelierForSave()
		const json = { ...getAtelierJson(atelierForSave), ...signaux }
		return dispatch(postAtelier(JSON.stringify(json), -1, !feedback)).then(
			(res) => {
				// Save refusé (400 clôture bloquée, 409 verrou, 500…) : postAtelier
				// résout sans json métier. Ne pas écraser le form local ni marquer
				// clean — sinon l'UI afficherait un état (ex. Clos) que le back a
				// refusé et que la base n'a pas.
				if (!res || !res.atelier) return res
				// `form` (closure) = l'état ENVOYÉ au serveur ; `formRef` =
				// l'état courant, qui peut avoir bougé pendant l'aller-retour
				// réseau. On repart du courant pour l'affichage — sinon la
				// saisie faite entre-temps était écrasée puis déclarée propre —
				// et on n'y reporte que les champs que le save a délibérément
				// posés (totaux recalculés, état forcé par l'appelant).
				const courant = formRef.current || form
				const resolus = Object.fromEntries(
					Object.entries(atelierForSave).filter(
						([champ, valeur]) => valeur !== form.atelier[champ],
					),
				)
				const newForm = {
					...courant,
					atelier: { ...courant.atelier, ...resolus },
				}
				// Ce qui est réellement en base : le form envoyé. C'est LUI la
				// nouvelle baseline, donc une saisie faite pendant le save reste
				// « modifiée » au lieu d'être perdue en silence.
				const persiste = { ...form, atelier: atelierForSave }
				// Création : reporter l'id serveur dans le form ET la baseline
				// AVANT de les poser. Sans ça, le form restait à id null tant
				// que la navigation ci-dessous n'avait pas rechargé la fiche —
				// et si elle était bloquée/annulée, un re-clic Sauvegarder
				// re-POSTait une CRÉATION (fiches en double du 31.07.2026).
				const creation = form.atelier.id === null
				if (creation) {
					newForm.atelier = { ...newForm.atelier, id: res.atelier.id }
					persiste.atelier = {
						...persiste.atelier,
						id: res.atelier.id,
					}
				}
				// Transactions : form ET baseline = la RÉPONSE, pas l'envoi. Une
				// ligne neuve part avec un id provisoire (Math.random(), cf.
				// restituer/SaveAtelierV2) et revient avec son id de base ; garder
				// l'envoi laissait l'id provisoire dans le form, que
				// mergeTransactionsV2 (refreshTransactions, appelé par le flux de
				// restitution) ne peut pas corréler à la ligne serveur → ligne
				// dupliquée dans le form, puis en base au save suivant (doublons
				// de restitution, 10.08.2026). Même corollaire assumé que les
				// heures : une ligne saisie pendant l'aller-retour est écrasée.
				if (res.atelier.transactionsv2) {
					const transactionsServeur = res.atelier.transactionsv2.map(
						(t) => ({
							...t,
							quittance: normalizePdf(t.quittance),
							facture: normalizePdf(t.facture),
						}),
					)
					newForm.atelier = {
						...newForm.atelier,
						transactionsv2: transactionsServeur,
					}
					persiste.atelier = {
						...persiste.atelier,
						transactionsv2: transactionsServeur,
					}
					// Demandes de suppression traitées par ce save.
					delete newForm.atelier.transactions_supprimees
					delete persiste.atelier.transactions_supprimees
				}
				// Resynchroniser les sous-traitants persistés : le save crée leurs lignes
				// AtelierSousTraitant (ids), nécessaires pour joindre un justificatif sans
				// recharger la fiche.
				if (res && res.sousTraitants) {
					const sousTraitantsPersistes = res.sousTraitants.map(
						(s) => ({ ...s }),
					)
					newForm.sousTraitants = sousTraitantsPersistes
					persiste.sousTraitants = sousTraitantsPersistes
				}
				// Lignes : même logique que les transactions. Une ligne neuve part
				// avec un id provisoire (Math.random()) et revient avec son id de
				// base ; garder l'envoi laissait l'id provisoire → au save suivant
				// le back (int(id) → 0) recréait la ligne et restockait/redébitait.
				// Les valeurs serveur (fourniturePaid, quantite_debitee, prixAchat
				// recalculé, debit_incomplet) sont aussi reprises ici.
				if (res.atelierLignes) {
					const lignesServeur = res.atelierLignes.map((l) => ({
						...l,
					}))
					newForm.atelierLignes = lignesServeur
					persiste.atelierLignes = lignesServeur
				}
				setForm(newForm)
				savedFormRef.current = JSON.stringify(persiste)
				// Heures : baseline = la RÉPONSE, pas l'envoi. Le reducer
				// remplace `atelierInfo.heures` par la liste serveur
				// (POST_ATELIER_SUCCESS), qui n'est jamais l'envoi tel quel —
				// une ligne neuve revient avec son id de base et les valeurs
				// normalisées ("3" saisi → 3.0). Comparer à l'envoi laissait la
				// fiche « modifiée » pour toujours après un save touchant aux
				// heures. Corollaire connu : une saisie d'heures faite pendant
				// l'aller-retour est écrasée par le reducer — défaut
				// préexistant, hors périmètre.
				savedHeuresRef.current = JSON.stringify(res.heures || [])
				// Pas de setClean() inconditionnel : le dirty-check recalcule
				// l'écart (form + heures + fichiers en attente) et tranche.
				if (creation) {
					// setClean() AVANT le replace, exception à la règle
					// ci-dessus : un setState hors handler d'événement flush en
					// SYNCHRONE (React 16), le <Prompt> du quit guard se re-rend
					// désarmé et laisse passer la navigation. Sans lui, le
					// replace était intercepté (« Quitter sans sauvegarder ? »
					// sur une fiche déjà sauvée — régression du rework 30.07).
					// Sans risque : le changement d':id recharge de toute façon
					// la fiche entière depuis le serveur.
					setClean()
					history.replace(`/atelier/fiche/${res.atelier.id}`)
				}
				if (typeof callback === "function") callback()
				if (feedback) {
					dispatch(
						showToast("success", "Modifications enregistrées."),
					)
				}
				return res
			},
		)
	}
	const updateEtatAndSave = (etat) =>
		save(null, { ...buildAtelierForSave(), etat })

	// Clôture : sauvegarde le form (transactions datées incluses) en forçant
	// etat=CLOS + paid, via `save` → le form (et donc l'UI) reflète bien la clôture.
	const confirmClore = () =>
		save(null, {
			...buildAtelierForSave(),
			etat: ATELIER_ETAT_CLOS,
			paid: true,
		})
	const downloadAtelierPdf = (pdfType, extra = "") => {
		fetch(
			`${URL}api/pdf?id=${form.atelier.id}&type=atelier&pdf_type=${pdfType}${extra}`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
			.then((response) => downloadPdfFromResponse(response))
			.catch((err) => dispatch(toastApiError(err)))
	}

	// Vérification des quantités d'inventaire avant transition (TRAVAUX_TERMINES / CLOS svp).
	const pendingQuantites = useRef(null)
	const pendingSignaux = useRef({})
	useEffect(() => {
		const st = atelierInfo.fetchAtelierQuantites
		if (!pendingQuantites.current || st.loading) return
		const pending = pendingQuantites.current
		const signaux = pendingSignaux.current
		pendingQuantites.current = null
		pendingSignaux.current = {}
		if (atelierInfo.atelierQuantites.length === 0) {
			// On NE ferme PAS SaveAtelierV2 ici : on laisse la modale montée pour
			// qu'elle affiche son propre feedback de sauvegarde (« Sauvegarde… » →
			// « Sauvegarde terminée »), comme toutes les autres transitions d'état.
			// La fermeture + dispatch(postAtelierReset()) se font via le bouton
			// « Fermer » de la modale (closeModal). Fermer ici démontait SaveAtelierV2
			// avant la fin du save async et faisait apparaître le SavingCustomModal
			// standard (l'app « reproposait » de sauvegarder).
			save(null, pending, { signaux })
		} else {
			// AtelierModalQuantitesV2 s'affiche (quantites > 0) : transition
			// abandonnée, bloquante depuis le 02.10 (plus de débit partiel).
			// SaveAtelierV2, restée montée sans save en cours, retomberait sur
			// « Sauvegarder ? » derrière le popup (QA Jordan 06.10) → on la ferme
			// comme son bouton « Fermer ».
			setSaveAtelierModal(false)
			dispatch(postAtelierReset())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [atelierInfo.fetchAtelierQuantites, atelierInfo.atelierQuantites])

	// Validation avant passage d'état → ouvre le modal SaveAtelier (avec erreurs).
	const checkFiche = (advancing = false) => {
		const a = form.atelier
		const heures = atelierInfo.heures
		const errors = []
		if (a.date.includes(" ") || a.date.length !== 10) errors.push("Date")
		if (a.employe === 0 && a.etat > ATELIER_ETAT_DEVIS_ACCEPTE)
			errors.push("Ajouter le mécanicien")
		// Kms exemptés pour les fiches client de passage (vente rapide, parfois
		// sans véhicule) — le champ n'y est d'ailleurs pas affiché. Une fiche
		// de réparation (GE-69, D4) les exige.
		if (
			["0", "", 0].includes(a.kms) &&
			a.etat >= ATELIER_ETAT_TRAVAUX_TERMINES &&
			!a.svp &&
			!isVenteRapide
		)
			errors.push("Ajouter le kilométrage")
		if (a.etat === ATELIER_ETAT_TRAVAUX_TERMINES) {
			// Heures exigées UNIQUEMENT au passage d'étape depuis « Travaux
			// terminés » (→ À restituer en normal, → Clos en svp) et seulement si
			// la fiche facture de la main-d'œuvre (décision Jordan 31.07.2026,
			// remplace celles des 23.07 et 29.07 : MO facturée ⇒ heures
			// justifiées ; vente de pièces pure = pas d'heures, y compris sur une
			// fiche svp). Sans MO, les heures ne regardent pas cette transition :
			// le garde-fou d'une ligne pourrie reste le 400 backend.
			const hasMainOeuvre = form.atelierLignes.some(
				(l) => l.type === ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
			)
			if (hasMainOeuvre) {
				if (heures.length === 0)
					errors.push("Ajouter les heures de travail")
				heures.forEach((h) => {
					if (
						h.description === "" ||
						!isValidDate(h.date) ||
						h.heures === "" ||
						h.employe === 0
					)
						errors.push("Contrôler les heures de travail")
				})
			}
		}
		if (
			advancing &&
			a.isAssurance &&
			!assurancePaneCompleted &&
			a.etat === ATELIER_ETAT_DEVIS_ACCEPTE
		)
			errors.push("Vérifier les informations assurance")
		if (errors.length > 0) dispatch(postAtelierErrorField(errors))
		setSaveNext(advancing)
		setSaveAtelierModal(true)
	}

	// Génération d'un devis manquant : ouvre le même popup que l'étape Devis
	// (SaveAtelierV2 section 3) sans avancer ni régresser l'état de la fiche.
	const genererDevis = () => {
		dispatch(postAtelierReset())
		setSaveNext(false)
		setDevisOnly(true)
		setSaveAtelierModal(true)
	}

	const getRestePayerFacturation = () => {
		let reste = totaux ? round20(totaux.totalTTC) : 0
		const facturePossible = moyenFacturePresent(moyenPaiements)
		form.atelier.transactionsv2.forEach((t) => {
			const estFacture = transactionEstFacture(t, moyenPaiements)
			// Une Facture ne compte qu'avec son PDF ; les autres moyens comptent
			// toujours (garde de présence du référentiel conservée du legacy).
			if (facturePossible && (!estFacture || t.facture)) reste -= t.total
		})
		return reste
	}

	const transactionsAFacturer = () => {
		if (form === null) return []
		const estAFacturer =
			form.atelier.etat === ATELIER_ETAT_OK_POUR_FACTURATION
		return form.atelier.transactionsv2.filter(
			(t) =>
				transactionEstFacture(t, moyenPaiements) &&
				t.payeParSelect !== PAYE_PAR_MASTER &&
				(estAFacturer || !t.facture),
		)
	}

	// Restitution : ajoute les transactions saisies, fait passer l'état
	// (en attente paiement, ou contrôle si assurance/facture), sauve, puis
	// génère la facture client si transaction non facturée.
	const setRestitution = (transactions) => {
		// Comme nextEtat : couper saveNext pour ne pas enchaîner sur la
		// confirmation de l'état suivant (ex. « Fiche prête pour la facturation »)
		// dès que l'état passe à contrôle/en attente paiement.
		setSaveNext(false)
		const facturePossible = moyenFacturePresent(moyenPaiements)
		let next = ATELIER_ETAT_EN_ATTENTE_PAIEMENT
		if (
			form.atelier.isAssurance ||
			transactions.some((t) => transactionEstFacture(t, moyenPaiements))
		)
			next = ATELIER_ETAT_CONTROLE_AVANT_FACTURATION
		const atelierForSave = {
			...form.atelier,
			total: totaux
				? HTtoTTC(totaux.sousTotHT, form.atelier.tva)
				: form.atelier.total,
			totalAchat: totaux ? totaux.totAchat : form.atelier.totalAchat,
			rabais: totaux ? totaux.rabaisHT : form.atelier.rabais,
			etat: next,
			transactionsv2: [...form.atelier.transactionsv2, ...transactions],
		}
		save(null, atelierForSave).then((json) => {
			const tClientNonFacture =
				json &&
				json.atelier &&
				json.atelier.transactionsv2.find(
					(t) =>
						facturePossible &&
						!transactionEstFacture(t, moyenPaiements) &&
						t.payeParSelect === PAYE_PAR_CLIENT,
				)
			if (tClientNonFacture) {
				fetch(
					`${URL}api/pdf?id=${form.atelier.id}&type=atelier&pdf_type=facture&transaction_id=${tClientNonFacture.id}`,
					{ headers: { Authorization: `Bearer ${token}` } },
				)
					.then((r) => downloadPdfFromResponse(r))
					.then(() => refreshTransactions())
					.catch((err) => dispatch(toastApiError(err)))
			}
		})
	}

	// Garde « dépannage payé » : avant restitution / passage en facturation,
	// si l'atelier est lié à un dépannage (dep !== 0), on vérifie qu'il est payé.
	const pendingDep = useRef(null)
	useEffect(() => {
		if (!pendingDep.current || restiDep.fetchDepPaid.loading) return
		const cb = pendingDep.current
		pendingDep.current = null
		if (restiDep.depPaid && restiDep.depPaid.paid) cb()
		else setModalRestiDep(true)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [restiDep.fetchDepPaid, restiDep.depPaid])
	const withDepPaid = (callback) => {
		if (form.atelier.dep === 0) {
			callback()
			return
		}
		pendingDep.current = callback
		dispatch(fetchDepPaid({ id: form.atelier.dep }))
	}

	// Garde « location restituée » : si l'atelier est lié à une location, on
	// vérifie qu'elle est restituée avant de restituer l'atelier.
	const withLocationRestitue = (callback) => {
		if (form.atelier.location === 0 || !form.atelier.location) {
			callback()
			return
		}
		setRedirectLoc({ show: true, state: 0, error: false })
		fetch(`${URL}api/locationisrestitue?id=${form.atelier.location}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				if (json.restitue) {
					setRedirectLoc({ show: false, state: 0, error: false })
					callback()
				} else {
					setRedirectLoc({ show: true, state: 1, error: false })
				}
			})
			.catch((err) =>
				setRedirectLoc({ show: true, state: 0, error: err }),
			)
	}

	// Crée une fiche location pré-remplie depuis la couverture location de
	// l'atelier. N'écrit rien en base : on sème les slices redux (entite +
	// location) puis on ouvre /location/fiche/0. Le lien atelier↔location est
	// établi côté back à la sauvegarde de la location (loc_data["atelier"]).
	// NB : le véhicule de prêt et les dates ne sont pas connus de l'atelier →
	// laissés vides. isPret reste false (prêt gratuit = évolution ultérieure).
	const creerLocationDepuisAtelier = (mode) => {
		const a = form.atelier
		const adresse =
			a.adresse ||
			(form.entite.adresses &&
				form.entite.adresses[0] &&
				form.entite.adresses[0].id) ||
			0
		const base = { atelier: a.id, adresse }
		let location
		if (mode === "pret") {
			// Prêt : le tarif journalier reste au défaut master ; la gratuité
			// est gérée à la création des transactions (isPret → payé par
			// Master / perte, côté SvpMobile).
			location = { ...base, isPret: true }
		} else if (atelierCouvertureLocationComplete(a)) {
			// Location assurée : pré-remplissage depuis la couverture.
			location = {
				...base,
				assurance: a.assuranceLocation,
				is_assurance: true,
				nbJoursCouverts: a.nbJoursLocation,
				tarifJourna: a.tarifJoursLocation,
				nRef: a.refLocation,
			}
		} else {
			// Location payante simple (tarif master par défaut).
			location = { ...base }
		}
		dispatch({
			type: "SET_LOCATION_FROM_ATELIER",
			value: { entite: form.entite, location },
		})
		history.push("/location/fiche/0")
	}

	// Envoi automatique du devis au client (transition « en attente client »).
	// Porté sur le modèle GE-25 : plus de send_type ni de part_types — on
	// résout le modèle par son CODE et on joint LE document devis qui vient
	// d'être généré (règle « proposé ⇔ le fichier existe » : s'il n'est pas
	// dans la liste, il n'existe pas).
	const envoyerDevisAuClient = (atelierId) => {
		Promise.all([
			dispatch(fetchEmailTemplates(EMAIL_DOMAINE_ATELIER)),
			dispatch(fetchEmailDocuments(atelierId, EMAIL_DOMAINE_ATELIER)),
		]).then(([templates, documents]) => {
			const modele = (templates || []).find(
				(t) => t.code === EMAIL_TEMPLATE_CODE_DEVIS && t.actif,
			)
			if (!modele) {
				// Silence impossible : sans modèle, aucun e-mail ne partirait et
				// personne ne le saurait.
				dispatch(
					showToast(
						"warning",
						"Devis généré, mais aucun modèle d'e-mail « devis » actif : e-mail non envoyé.",
					),
				)
				return
			}
			const devis = (documents || []).filter(
				(d) => d.file_type === ATELIER_FILE_TYPE_DEVIS,
			)
			dispatch(
				postEmail({
					domaine: EMAIL_DOMAINE_ATELIER,
					fiche_id: atelierId,
					recipient: form.entite.email,
					template_id: modele.id,
					destinataire_type: modele.destinataire_type,
					pieces: devis.map((d) => ({ kind: d.kind, id: d.id })),
				}),
			)
		})
	}

	// Transition d'état (porté du legacy nextEtat).
	const nextEtat = (next, extraData = {}) => {
		const a = { ...form.atelier }
		setSaveNext(false)
		switch (next) {
			case ATELIER_ETAT_EN_ATTENTE_CLIENT:
				save(
					() => {
						fetch(
							`${URL}api/pdf?id=${a.id}&type=atelier&pdf_type=devis&sous_reserve=${!!extraData.sousReserve}`,
							{ headers: { Authorization: `Bearer ${token}` } },
						).then((response) => {
							dispatch(fetchAtelierFiles(a.id))
							if (extraData.imprimerDevis)
								downloadPdfFromResponse(response).catch((err) =>
									dispatch(toastApiError(err)),
								)
							else envoyerDevisAuClient(a.id)
						})
					},
					{
						...a,
						etat: extraData.keepEtat
							? a.etat
							: ATELIER_ETAT_EN_ATTENTE_CLIENT,
					},
				)
				break
			case ATELIER_ETAT_DEVIS_ACCEPTE:
				if (!extraData.devisAccepte) return
				save(null, { ...a, etat: ATELIER_ETAT_DEVIS_ACCEPTE })
				break
			case ATELIER_ETAT_TRAVAUX_EN_COURS:
				save(() => downloadAtelierPdf("fiche_travail"), {
					...a,
					etat: ATELIER_ETAT_TRAVAUX_EN_COURS,
					employe: extraData.employeId,
				})
				break
			case ATELIER_ETAT_TRAVAUX_TERMINES:
				pendingQuantites.current = {
					...a,
					etat: ATELIER_ETAT_TRAVAUX_TERMINES,
				}
				dispatch(
					fetchAtelierQuantites(
						JSON.stringify({ alCheck: [...form.atelierLignes] }),
					),
				)
				break
			case ATELIER_ETAT_A_RESTITUER:
				save(null, {
					...a,
					etat: ATELIER_ETAT_A_RESTITUER,
					kms_prochain_travaux: parseInt(a.kms) + 15000,
				})
				break
			case ATELIER_ETAT_CONTROLE_AVANT_FACTURATION:
				save(null, {
					...a,
					etat: ATELIER_ETAT_CONTROLE_AVANT_FACTURATION,
				})
				break
			case ATELIER_ETAT_OK_POUR_FACTURATION:
				withDepPaid(() =>
					save(null, {
						...a,
						etat: ATELIER_ETAT_OK_POUR_FACTURATION,
					}),
				)
				break
			case ATELIER_ETAT_CLOS:
				if (a.svp) {
					pendingQuantites.current = { ...a, etat: ATELIER_ETAT_CLOS }
					// GE-77 : « Dégâts réparés » coché dans « Clore l'entretien ? ».
					pendingSignaux.current = extraData.remettreDegatsAZero
						? { remettre_degats_a_zero: true }
						: {}
					dispatch(
						fetchAtelierQuantites(
							JSON.stringify({
								alCheck: [...form.atelierLignes],
							}),
						),
					)
				} else {
					save(null, { ...a, etat: ATELIER_ETAT_CLOS })
				}
				break
			default:
				save(null, { ...a, etat: next })
				break
		}
	}

	// Applique la modif de prix de vente (mode 0 = dupliquer/participation, 1 = prix direct).
	const applyModifierPrix = (ligne, menu, pct, newPrix) => {
		setForm((f) => {
			const idx = f.atelierLignes.findIndex((l) => l.id === ligne.id)
			if (idx === -1) return f
			const tempAL = { ...ligne, prixVenteModifie: true }
			let toAdd
			if (menu === 0) {
				const p = parseFloat(pct)
				const participation = {
					...ligne,
					id: Math.random(),
					label: `Participation client ${pct}%: ${ligne.label}`,
					prixVente: round100(ligne.prixVente * (p / 100)),
					prixAchat: 0,
					// Ligne purement financière : ne doit débiter AUCUN stock
					// (ni virtuel ni réel — `article` serait hérité du spread
					// et débiterait l'inventaire une 2e fois).
					articleVirtuel: 0,
					article: 0,
					payePar: PAYE_PAR_CLIENT,
					prixVenteModifie: false,
					dupliquer_from: ligne.id,
				}
				tempAL.prixVenteFirstValue = ligne.prixVente
				tempAL.prixVente = round100(ligne.prixVente * ((100 - p) / 100))
				toAdd = [tempAL, participation]
			} else {
				tempAL.prixVente = newPrix
				toAdd = [tempAL]
			}
			return {
				...f,
				atelierLignes: [
					...f.atelierLignes.slice(0, idx),
					...toAdd,
					...f.atelierLignes.slice(idx + 1),
				],
			}
		})
		setModifierPrixLigne(null)
	}

	// --- Commentaires (state local immuable) ------------------------------
	const updateAtelierCommentaires = (value, id, field) => {
		setForm((f) => ({
			...f,
			atelierCommentaires: f.atelierCommentaires.map((c) =>
				c.id === id ? { ...c, [field]: value } : c,
			),
		}))
	}
	const addAtelierCommentaires = (print) => {
		setForm((f) => ({
			...f,
			atelierCommentaires: [
				...f.atelierCommentaires,
				{ id: Math.random() * 1000, texte: "", marked: false, print },
			],
		}))
	}
	const removeAtelierCommentaires = (id) => {
		setForm((f) => ({
			...f,
			atelierCommentaires: f.atelierCommentaires.filter(
				(c) => c.id !== id,
			),
		}))
	}

	// --- Transactions (state local immuable, modèle transactionsv2) -------
	const updateTransactions = (field, value, index) => {
		const v = ["caissier", "moyenPaie", "payeParSelect"].includes(field)
			? parseInt(value)
			: value
		setForm((f) => ({
			...f,
			atelier: {
				...f.atelier,
				transactionsv2: f.atelier.transactionsv2.map((t, i) => {
					if (i !== index) return t
					const updated = { ...t, [field]: v }
					if (field === "payeParSelect" && v === PAYE_PAR_MASTER)
						return appliquerPerte(updated)
					return updated
				}),
			},
		}))
	}
	const removeTransaction = (id) => {
		setForm((f) => ({
			...f,
			atelier: {
				...f.atelier,
				transactionsv2: f.atelier.transactionsv2.filter(
					(t) => t.id !== id,
				),
				// Jordan 19.10 : une ligne protégée (datée, WinBIZ,
				// rapprochée…) ne part qu'avec une demande explicite (boss).
				...(Number.isInteger(id)
					? {
							transactions_supprimees: [
								...(f.atelier.transactions_supprimees || []),
								id,
							],
						}
					: {}),
			},
		}))
	}
	// Jordan 19.10 : lignes ENREGISTRÉES (valeurs, WinBIZ, rapprochement)
	// relues via api/transactionv2 (web seul) à chaque chargement / save.
	const [transactionsServeur, setTransactionsServeur] = useState([])
	useEffect(() => {
		const ficheId = (atelierInfo.atelier || {}).id
		if (!Number.isInteger(ficheId) || ficheId <= 0) {
			setTransactionsServeur([])
			return
		}
		let actif = true
		fetch(`${URL}api/transactionv2?atelier_id=${ficheId}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then((res) => res.json())
			.then((json) => {
				if (actif && Array.isArray(json)) setTransactionsServeur(json)
			})
			.catch(() => {})
		return () => {
			actif = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [atelierInfo.atelier])
	// Fiche close d'après l'état ENREGISTRÉ (celui que le serveur applique).
	const ficheClose = (atelierInfo.atelier || {}).etat === ATELIER_ETAT_CLOS
	const consequencesSave = () =>
		consequencesTransactions({
			transactions: form.atelier.transactionsv2.map((tx) =>
				avecServeur(tx, transactionsServeur),
			),
			supprimees: (form.atelier.transactions_supprimees || [])
				.map((i) => transactionsServeur.find((b) => b.id === i))
				.filter(Boolean)
				.map((b) => avecServeur(b, transactionsServeur)),
			close: ficheClose,
		})
	const addTransaction = (raison = "") => {
		setForm((f) => ({
			...f,
			atelier: {
				...f.atelier,
				transactionsv2: [
					...f.atelier.transactionsv2,
					{
						...getBaseTransactionV2(),
						id: Math.random(),
						atelier: f.atelier.id,
						raison,
					},
				],
			},
		}))
	}

	// Recharge les transactions depuis le serveur et met à jour le form local
	// (documents normalisés). Utilisé après génération/suppression de document,
	// comme LocationV2.refreshTransactions.
	const refreshTransactions = async () => {
		const res = await fetch(
			`${URL}api/transactionv2?atelier_id=${form.atelier.id}`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
		const json = await res.json()
		const distantes = (Array.isArray(json) ? json : []).map((t) => ({
			...t,
			quittance: normalizePdf(t.quittance),
			facture: normalizePdf(t.facture),
		}))
		// Fusion (cf. utilities/transactionsV2) : le refetch n'apporte que les
		// documents, il ne doit pas effacer une ligne en cours de saisie.
		const patch = (a) => ({
			...a,
			transactionsv2: mergeTransactionsV2(a.transactionsv2, distantes),
		})
		setForm((f) => ({ ...f, atelier: patch(f.atelier) }))
		// Même transformation sur la baseline : l'action est déjà persistée, la
		// fiche ne doit pas passer « modifiée » pour autant (Imprimer grisé,
		// popup de sortie injustifiée) — seul l'écart réellement saisi reste.
		if (savedFormRef.current) {
			const base = JSON.parse(savedFormRef.current)
			base.atelier = patch(base.atelier)
			savedFormRef.current = JSON.stringify(base)
		}
		// Synchroniser le store redux (lu par le modal e-mail via
		// useAtelierTransactionFiles) → facture/quittance dispo sans recharger (F5).
		dispatch({
			type: "SET_ATELIER",
			value: { ...atelierInfo.atelier, transactionsv2: json },
		})
	}

	// Génère la quittance d'une transaction côté serveur : api/pdf avec
	// `pdf_type=facture` (la quittance atelier EST un document facture), puis
	// re-fetch des transactions pour rapatrier le document dans le form local.
	const generateQuittance = async (transactionId) => {
		const response = await fetch(
			`${URL}api/pdf?id=${form.atelier.id}&transaction_id=${transactionId}&type=atelier&pdf_type=facture`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
		try {
			await downloadPdfFromResponse(response)
		} catch (err) {
			dispatch(toastApiError(err))
			return
		}
		await refreshTransactions()
	}
	const deleteTransactionDoc = (transaction_id, doc_to_delete) => {
		fetch(`${URL}api/transactionv2`, {
			method: "DELETE",
			body: JSON.stringify({
				transaction_id,
				doc_to_delete,
				// Revue 7 (Lg8) : la fiche de la ligne.
				atelier_id: form.atelier.id,
			}),
			headers: { Authorization: `Bearer ${token}` },
		})
			// QA 12.10 : refus du serveur (ex. 403 « seul un boss ou un admin
			// retire ce document ») affiché en toast, plus avalé.
			.then(handleErrors)
			.then(refreshTransactions)
			.catch(catchApiError(dispatch, null))
	}
	// Upload immédiat d'une facture sur une transaction (pas de modal) : PUT
	// api/transactionv2 (facture_<id>) puis re-fetch, comme generateQuittance.
	// Revue 27.10 (I1) : un refus (fiche close, droits) est affiché en toast,
	// plus avalé ; le re-fetch rapatrie la date posée au dépôt.
	const uploadTransactionFacture = (transactionId, file) => {
		const formData = new FormData()
		formData.append("id", form.atelier.id)
		formData.append(`facture_${transactionId}`, file)
		return fetch(`${URL}api/transactionv2`, {
			method: "put",
			headers: { Authorization: `Bearer ${token}` },
			body: formData,
		})
			.then(handleErrors)
			.then(refreshTransactions)
			.catch(catchApiError(dispatch, null))
	}

	// --- Fichiers (hors form, contre redux) -------------------------------
	// Une pièce jointe porte une FK vers la fiche : tant que celle-ci n'existe
	// pas en base, l'upload ne PEUT pas aboutir (le front envoyait `null`, que
	// FormData transporte en chaîne "null" → 500 côté serveur).
	const ficheEnregistree = atelier.id !== null && atelier.id !== undefined
	const addPendingFiles = (e, type) => {
		const files = Array.from(e.target.files).map((file) => ({ file, type }))
		setPendingFiles((prev) => [...prev, ...files])
		e.target.value = ""
	}
	const postFiles = () => {
		if (pendingFiles.length === 0 || !ficheEnregistree) return
		const formData = new FormData()
		formData.append("id", atelier.id)
		pendingFiles.forEach((pf, index) => {
			formData.append(`file_${index}_${pf.type}`, pf.file)
		})
		dispatch(postAtelierFiles(formData))
	}
	// Le succès remplace atelier.files en redux → on vide la file d'attente.
	useEffect(() => {
		if (
			atelierInfo.postAtelierFiles &&
			atelierInfo.postAtelierFiles.saved
		) {
			setPendingFiles([])
			dispatch(postAtelierFilesReset())
		}
	}, [atelierInfo.postAtelierFiles, dispatch])

	// Document de restitution signé (géré hors form, via redux).
	const uploadDocRestitution = (file) => {
		if (!file || !ficheEnregistree) return
		const formData = new FormData()
		formData.append("id", atelier.id)
		formData.append("doc_restitution", file)
		dispatch(postAtelierDocRestitution(formData)).then(() => {
			setTimeout(() => dispatch(postAtelierDocRestitutionReset()), 1000)
		})
	}
	const deleteDocRestitution = () => {
		dispatch(atelierDeleteDocRestitution(atelier.id))
	}

	const savedFilesByType = (type) =>
		atelier.files.filter((f) => f.id && f.type === type)
	const pendingByType = (type) => pendingFiles.filter((p) => p.type === type)
	const deleteFileDispatch = (id) => dispatch(deleteAtelierFile({ id }))
	const resetDeleteFile = () => dispatch(deleteAtelierFileReset())

	// Adresse sélectionnée de l'entité (lecture seule dans la fiche).
	const adresseMemo = useMemo(() => {
		if (form === null) return null
		const { entite: ent, atelier: ate } = form
		if (
			!ent ||
			ent.id === null ||
			ate.adresse === null ||
			!ent.adresses ||
			ent.adresses.length === 0
		)
			return null
		return ent.adresses.find((adr) => adr.id === ate.adresse) || null
	}, [form])

	// Véhicule sélectionné de l'entité (lecture seule).
	const vehiculeSelectionne = useMemo(() => {
		if (form === null || !form.entite || !form.entite.vehicules) return null
		return (
			form.entite.vehicules.find((v) => v.id === form.atelier.vehicule) ||
			null
		)
	}, [form])

	// ─── Œil de la ligne Véhicule (fiche d'entretien) ───
	// Ouvre le modal de la flotte (/configuration → Véhicule) sans les actions
	// de parc (sortie, suppression), par l'accès dédié
	// `api/vehicule/fiche-entretien` : lecture + modification d'un véhicule
	// EXISTANT de la flotte, droit `vehicule_fiche_entretien` (boss,
	// responsable_atelier, admin_atelier). La configuration de la flotte
	// (création, suppression, sortie) reste au boss.
	// Le véhicule est relu à l'ouverture (dates converties en ISO pour les
	// champs date : le serializer les émet en JJ-MM-AAAA).
	// Disponible même fiche verrouillée : on modifie le véhicule, pas la fiche.
	const [vehiculeModal, setVehiculeModal] = useState(null)
	const ouvrirVehicule = () => {
		const vid = vehiculeSelectionne && vehiculeSelectionne.id
		if (!vid) return
		dispatch(fetchVehiculeFicheEntretien(vid)).then((v) => {
			if (!v) return
			setVehiculeModal({
				...v,
				date_mise_en_circu: frToIso(v.date_mise_en_circu),
				expertise_le: frToIso(v.expertise_le),
			})
		})
	}
	// À la fermeture : la fiche reprend le véhicule relu sur le serveur
	// (plaques, marque, modèle, parties → libellé de la partie, documents
	// envoyés depuis le modal). Déjà persisté : la baseline reçoit le même
	// patch, la fiche ne passe pas « modifiée » pour autant. Les dates restent
	// celles de la fiche.
	const fermerVehicule = () => {
		const vid = vehiculeModal.id
		setVehiculeModal(null)
		dispatch(fetchVehiculeFicheEntretien(vid)).then((frais) => {
			if (frais) reprendreVehicule(vid, frais)
		})
	}
	const reprendreVehicule = (vid, frais) => {
		const patch = (ent) => ({
			...ent,
			vehicules: (ent.vehicules || []).map((v) =>
				v.id === vid
					? {
							...v,
							plaques: frais.plaques,
							marque: frais.marque,
							modele: frais.modele,
							chassis: frais.chassis,
							kms: frais.kms,
							status: frais.status,
							propre_vehicule: frais.propre_vehicule,
							files: frais.files,
							carte_grise: frais.carte_grise,
						}
					: v,
			),
		})
		setForm((f) => (f ? { ...f, entite: patch(f.entite) } : f))
		if (savedFormRef.current) {
			const base = JSON.parse(savedFormRef.current)
			base.entite = patch(base.entite)
			savedFormRef.current = JSON.stringify(base)
		}
	}

	// Le véhicule a-t-il des documents à afficher (photos ou carte grise
	// enregistrée) ? Conditionne l'affichage de la carte « Documents véhicule ».
	const hasVehiculeDocs = useMemo(() => {
		if (!vehiculeSelectionne) return false
		const files = vehiculeSelectionne.files || []
		const cg = vehiculeSelectionne.carte_grise
		return files.length > 0 || (cg && cg.saved)
	}, [vehiculeSelectionne])

	// Libellé de la partie (fiches SVP) : résolu depuis les parties du véhicule
	// sélectionné via l'id `form.atelier.partie`. Vide si pas de partie.
	const partieLabel = useMemo(() => {
		if (form === null || !form.atelier.partie || !vehiculeSelectionne)
			return ""
		const parties =
			(vehiculeSelectionne.propre_vehicule &&
				vehiculeSelectionne.propre_vehicule.parties) ||
			[]
		const p = parties.find((x) => x.id === form.atelier.partie)
		return p ? p.label : ""
	}, [form, vehiculeSelectionne])

	// Bascule mode assurance. Si de la main d'œuvre est déjà saisie, le tarif
	// horaire change → on confirme via un CustomModal (conventions V2).
	// Reprice les lignes MO (non-forfait) et réinitialise les champs assurance
	// au désactivement (cf. AtelierSwitchAssuranceModal legacy).
	// Applique la bascule assurance. `chosenAssurance` = assurance retenue quand
	// on active (sinon on garde l'existante). Reprice les lignes MO (non-forfait)
	// et réinitialise les champs assurance au désactivement.
	const applyToggleAssurance = (chosenAssurance = null) => {
		const newIsAssurance = !form.atelier.isAssurance
		const newPayePar = newIsAssurance ? PAYE_PAR_ASSURANCE : PAYE_PAR_CLIENT
		const assForReprice = newIsAssurance
			? chosenAssurance !== null
				? chosenAssurance
				: form.atelier.assurance
			: null
		const { prixVente, rabais } = getPrixVenteRabaisMainOeuvre(
			ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
			newPayePar,
			assForReprice,
		)
		setForm((f) => {
			const lignes = f.atelierLignes.map((al) =>
				al.type === ATELIER_LIGNE_TYPE_MAIN_OEUVRE && !al.isForfait
					? {
							...al,
							prixVente,
							rabais,
							isHT: true,
							rabaisIsFlat: true,
							payePar: newPayePar,
						}
					: al,
			)
			let atelier = { ...f.atelier, isAssurance: newIsAssurance }
			if (newIsAssurance) {
				if (chosenAssurance !== null)
					atelier.assurance = chosenAssurance
			} else {
				atelier = {
					...atelier,
					assurance: 0,
					numeroSinistre: "",
					expert: 0,
					expertNom: "",
					audatexPhotoFacture: 0,
					franchise: 0,
					rabaisFranchise: 0,
					isCouvertLocation: 0,
					assuranceRemarques: "",
					assuranceLocation: 0,
					refLocation: "",
					nbJoursLocation: 0,
					tarifJoursLocation: 0,
				}
			}
			return { ...f, atelier, atelierLignes: lignes }
		})
		setModalSwitchAssurance(false)
		// À l'activation : focus le select Assurance (la carte vient de monter) →
		// saisie au clavier directe, Entrée enchaîne jusqu'à Remarques.
		if (newIsAssurance) {
			setTimeout(() => {
				if (refAssurance.current) refAssurance.current.focus()
			}, 0)
		}
	}
	// Clic sur le toggler : ouvre toujours le modal (choix de l'assurance à
	// l'activation, confirmation à la désactivation).
	const onClickAssurance = () => {
		setSwitchAssuranceSel(form.atelier.assurance || 0)
		setModalSwitchAssurance(true)
	}

	// Pastille "complété" de la carte assurance (n° sinistre + audatex/expert ou photo facture).
	const assurancePaneCompleted = useMemo(() => {
		if (form === null) return false
		const a = form.atelier
		return (
			a.numeroSinistre !== "" &&
			(a.audatexPhotoFacture === ATELIER_PHOTO_FACTURE ||
				(a.audatexPhotoFacture === ATELIER_AUDATEX && a.expert > 0))
		)
	}, [form])

	// Totaux (HT / TVA / rabais / marge / TTC) calculés depuis les lignes.
	const totaux = useMemo(() => {
		if (form === null) return null
		const tva = form.atelier.tva
		let rabaisHT = 0
		let sousTotHT = 0
		let totAchat = 0
		let totAss = 0
		let totClient = 0
		form.atelierLignes.forEach((aL) => {
			let alSousTotHT = aL.isHT
				? aL.quantite * aL.prixVente
				: aL.quantite * TTCtoHT(aL.prixVente, tva)
			if (aL.rabaisIsFlat) {
				alSousTotHT -= aL.quantite * aL.rabais
				rabaisHT += aL.quantite * aL.rabais
			} else {
				rabaisHT += (alSousTotHT * aL.rabais) / 100
				alSousTotHT -= (alSousTotHT * aL.rabais) / 100
			}
			sousTotHT += alSousTotHT
			if (parseInt(aL.payePar) === PAYE_PAR_ASSURANCE)
				totAss += alSousTotHT
			else if (parseInt(aL.payePar) === PAYE_PAR_CLIENT)
				totClient += alSousTotHT
			totAchat += aL.isAchHT
				? aL.quantite * aL.prixAchat
				: aL.quantite * TTCtoHT(aL.prixAchat, tva)
		})
		const franchise =
			form.atelier.franchise !== ""
				? parseFloat(form.atelier.franchise)
				: 0
		const rabaisFranchise =
			form.atelier.rabaisFranchise !== ""
				? parseFloat(form.atelier.rabaisFranchise)
				: 0
		const totTva = (sousTotHT * tva) / 100
		const totTvaClient = (totClient * tva) / 100
		const totTvaAssurance = (totAss * tva) / 100
		const isSociete = form.entite.type === ENTITE_TYPE_SOCIETE
		const totalTTC = HTtoTTC(sousTotHT, tva)
		const marge = sousTotHT - totAchat - TTCtoHT(rabaisFranchise, tva)
		// Total client TTC
		let totClientTTC
		if (!form.atelier.isAssurance || isSociete)
			totClientTTC = totClient + totTva
		else totClientTTC = totClient + totTvaClient
		totClientTTC += franchise - rabaisFranchise
		// Total assurance TTC
		let totAssTTC = 0
		if (form.atelier.isAssurance) {
			totAssTTC = isSociete ? totAss : totAss + totTvaAssurance
			totAssTTC -= franchise
		}
		const rabaisTotalHT = rabaisHT + TTCtoHT(rabaisFranchise, tva)
		return {
			sousTotHT,
			totTva,
			totAchat,
			rabaisHT: rabaisTotalHT,
			rabaisPc:
				sousTotHT + rabaisHT
					? (rabaisTotalHT / (sousTotHT + rabaisHT)) * 100
					: 0,
			marge,
			margePc: sousTotHT ? (marge / sousTotHT) * 100 : 0,
			totalTTC,
			totClientTTC,
			totAssTTC,
			coutEntretienTTC: round20(totAchat),
		}
	}, [form])

	// NB : total / totalAchat / rabais ne sont PAS réécrits dans le form en
	// continu (cela marquerait la fiche « modifiée » dès le chargement). Ils
	// seront calculés depuis `totaux` au moment du save (Phase 12) et pour le
	// reste à payer des transactions (Phase 8).

	// Reste à payer = total TTC - somme des transactions.
	const restePayer = useMemo(() => {
		if (form === null || totaux === null) return 0
		let totTrans = 0
		form.atelier.transactionsv2.forEach((t) => {
			const v = parseFloat(t.total)
			if (!Number.isNaN(v)) totTrans += v
		})
		return round20(totaux.totalTTC - totTrans)
	}, [form, totaux])

	// Statut de la carte Restitution : complété si le document signé est sauvé,
	// sinon incomplet (badge ambre). Précalculé pour garder l'attribut JSX trivial.
	const restitutionStatus =
		atelier.doc_restitution && atelier.doc_restitution.saved
			? "complete"
			: "incomplete"

	// Résumé sous-traitance : totaux recalculés depuis les lignes, en préservant
	// payeLe/file/id chargés (form.sousTraitants).
	const sousTraitantsMerged = useMemo(() => {
		if (form === null) return []
		const map = new Map()
		form.sousTraitants.forEach((st) => {
			map.set(st.sousTraitant, {
				...st,
				totalMainOeuvres: 0,
				totalFournitures: 0,
				totalAutres: 0,
			})
		})
		form.atelierLignes.forEach((al) => {
			if (al.sousTraitant === 0) return
			if (!map.has(al.sousTraitant)) {
				const f = fournisseurs.find((x) => x.id === al.sousTraitant)
				map.set(al.sousTraitant, {
					id: null,
					sousTraitant: al.sousTraitant,
					label: f ? f.label : "",
					totalMainOeuvres: 0,
					totalFournitures: 0,
					totalAutres: 0,
					payeLe: "",
					file: null,
				})
			}
			const entry = map.get(al.sousTraitant)
			if (al.quantite !== "" && al.prixAchat !== "") {
				const amt = al.quantite * al.prixAchat
				if (al.type === ATELIER_LIGNE_TYPE_FOURNITURE)
					entry.totalFournitures += amt
				else if (al.type === ATELIER_LIGNE_TYPE_MAIN_OEUVRE)
					entry.totalMainOeuvres += amt
				else if (al.type === ATELIER_LIGNE_TYPE_AUTRE)
					entry.totalAutres += amt
			}
		})
		return Array.from(map.values()).filter(
			(st) =>
				st.totalMainOeuvres || st.totalFournitures || st.totalAutres,
		)
	}, [form, fournisseurs])

	// Destinataires proposés au modal e-mail : seule la fiche connaît son
	// client, son assurance, son expert et ses sous-traitants. Le type pilote
	// les modèles disponibles (un modèle = un type de destinataire, GE-25).
	const destinatairesEmail = useMemo(() => {
		if (form === null) return []
		const liste = []
		const estSociete = form.entite.type === ENTITE_TYPE_SOCIETE
		liste.push({
			type: estSociete
				? EMAIL_DESTINATAIRE_CLIENT_SOCIETE
				: EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
			email: form.entite.email || "",
			label: "Client",
		})
		if (form.atelier.assurance > 0) {
			const ass = assurances.find((a) => a.id === form.atelier.assurance)
			liste.push({
				type: EMAIL_DESTINATAIRE_ASSURANCE,
				email: ass ? ass.email || "" : "",
				label: "Assurance",
			})
		}
		if (form.atelier.expert > 0) {
			const exp = experts.find((e) => e.id === form.atelier.expert)
			liste.push({
				type: EMAIL_DESTINATAIRE_EXPERT,
				email: exp ? exp.email || "" : "",
				label: "Expert",
			})
		}
		sousTraitantsMerged.forEach((st) => {
			if (!st.email) return
			liste.push({
				type: EMAIL_DESTINATAIRE_SOUS_TRAITANT,
				email: st.email,
				label: st.label || "Sous-traitant",
			})
		})
		liste.push({
			type: EMAIL_DESTINATAIRE_LIBRE,
			email: "",
			label: "Libre",
		})
		return liste
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form, assurances, experts, sousTraitantsMerged])

	const updateSousTraitant = (key, value, index) => {
		const target = sousTraitantsMerged[index]
		if (!target) return
		setForm((f) => {
			const list = [...f.sousTraitants]
			const i = list.findIndex(
				(s) => s.sousTraitant === target.sousTraitant,
			)
			if (i === -1) list.push({ ...target, [key]: value })
			else list[i] = { ...list[i], [key]: value }
			return { ...f, sousTraitants: list }
		})
	}

	// ⚠ Ces 4 derniers hooks sont AVANT les dérivés (isVenteRapide,
	// showTransactionsCard, …) et pas après : eslint-plugin-react-hooks 1.7.0
	// (CRA 3) compte les chemins d'exécution en flottants et déborde sur un
	// composant de cette taille → faux positifs « called conditionally » dès
	// qu'on ajoute/retire une condition dans le rendu. Moins de `&&` en amont
	// d'un hook = comptage stable. Même famille de contournement que le hoist
	// de showTransactionsCard plus bas.
	// Options expert pour le FilteredSelectV2 : libellé filtrable « Nom Prénom »
	// + entité affichée en second dans la liste déroulante.
	const expertOptions = useMemo(
		() =>
			(experts || []).map((e) => ({
				id: e.id,
				label: `${e.nom} ${e.prenom}`,
				entite: e.entite_label,
			})),
		[experts],
	)

	// QR vers l'app mobile : ouvre directement la fiche atelier sur le mobile.
	// Repli sur la recherche tant que la fiche n'est pas enregistrée.
	const qrUrl = useMemo(
		() =>
			form && form.atelier.id > 0
				? `svpmobile://main/atelier/fiche/${form.atelier.id}`
				: "svpmobile://main/atelier/recherche",
		[form],
	)

	const headerBadge = useMemo(() => {
		if (form === null) return null
		const [color, bg] = etatBadgeStyle(form.atelier.etat)
		return (
			<span
				style={{
					...generalStyles.badge(color, bg),
					...generalStyles.entete,
				}}
			>
				{etatLabel(form.atelier.etat)}
			</span>
		)
	}, [form])

	// ≥ 25 : reliquat non débité (clôture bloquée) ; 15/20 : une pièce n'est
	// pas couverte par le stock disponible (flags calculés par le back).
	const stockBadge = useMemo(() => {
		if (form === null) return null
		const termine = form.atelier.etat >= ATELIER_ETAT_TRAVAUX_TERMINES
		const flag = termine ? "debit_incomplet" : "piece_a_commander"
		if (!form.atelierLignes.some((l) => l[flag])) return null
		return (
			<span
				style={{
					...generalStyles.badge(COLORS.warning, COLORS.warningLight),
					...generalStyles.entete,
				}}
			>
				<FontAwesomeIcon
					icon={faExclamationTriangle}
					style={{ marginRight: 4 }}
				/>
				{termine ? "Stock non débité" : "Pièce à commander"}
			</span>
		)
	}, [form])

	// Touche Échap = retour à la recherche, MÊME depuis un champ (comme le
	// dépannage, Jordan 31.10.2026). Ignoré si une liste à suggestions ouverte
	// l'a consommé ou si un modal est ouvert (echapFiche.js + anyModalOpen).
	useEffect(() => {
		const onKey = (e) => {
			if (e.key !== "Escape") return
			if (form === null || !Number.isInteger(form.atelier.id)) return
			if (anyModalOpen || echapIgnoreParFiche(e)) return
			// Échap = simple retour à la recherche, quel que soit l'état de la
			// fiche. Plus de rituel de fermeture : le verrou est libéré par le
			// cleanup au démontage, le slice GARDE l'id (le bouton nav
			// « Fiche » y ramène) et useQuitGuard s'occupe des modifs non
			// sauvegardées. Destination = le tableau s'il reste des résultats,
			// sinon le formulaire (règle unifiée des 3 fiches, 31.07.2026 :
			// une recherche à 0 résultat renvoie au formulaire, pas sur un
			// tableau vide).
			history.push(
				atelierFiches.length > 0
					? "/atelier/resultats"
					: "/atelier/rechercher",
			)
		}
		window.addEventListener("keydown", onKey)
		return () => window.removeEventListener("keydown", onKey)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form, anyModalOpen, atelierFiches])

	// Carte « Heures de travail » : condition d'affichage seule (le verrou de
	// sauvegarde du 29.07 a été supprimé le 31.07 — les heures ne sont plus
	// exigées qu'au clic « Étape suivante », voir checkFiche). Hoisté hors
	// du JSX comme showTransactionsCard (faux positifs rules-of-hooks du vieux
	// plugin CRA 3 sur les conditions composées dans le rendu).
	const carteHeuresAffichee =
		form !== null &&
		permissions.canSeeCarteHeures &&
		(form.atelier.svp
			? form.atelier.etat >= ATELIER_ETAT_TRAVAUX_EN_COURS
			: form.atelier.etat >= ATELIER_ETAT_TRAVAUX_TERMINES)
	// Une ligne d'heures est exploitable quand ses 4 champs sont posés — critère
	// du badge « complété » de la carte.
	const heuresCompletes =
		atelierInfo.heures.length > 0 &&
		atelierInfo.heures.every(
			(h) =>
				h.description !== "" &&
				isValidDate(h.date) &&
				h.heures !== "" &&
				h.employe !== 0,
		)

	// Règles « vente rapide » (kms, rabais, marge, location) — cf.
	// estVenteRapide (une fiche de réparation n'en relève pas, D4).
	const isVenteRapide = estVenteRapide(form)
	// Bloc Transactions : visible aussi VIDE dès « À restituer » (le bouton
	// « Ajouter une transaction » vit dedans — sans ça, fiche sans transaction
	// = bouton inatteignable, poule et œuf ; fix client de passage 23.07).
	// ⚠ Condition hoistée ici et PAS inline dans le JSX : le vieux
	// eslint-plugin-react-hooks de CRA 3 sort des faux positifs rules-of-hooks
	// sur ce genre de condition composée dans le rendu (cf. tasks.md).
	const showTransactionsCard =
		form !== null &&
		(form.atelier.transactionsv2.length > 0 ||
			form.atelier.etat >= ATELIER_ETAT_A_RESTITUER)
	// État « devis à faire » : on n'affiche que les blocs Assurance + Commentaires
	// (et pas le bouton Imprimer).
	const isDevisAFaire =
		form !== null && form.atelier.etat === ATELIER_ETAT_DEVIS_A_FAIRE
	// Jordan 27.10 : Clos retiré du sélecteur pour tous sauf le boss (les
	// autres closent par « Clore » / « Facturer », contrôlés) ; gardé si la
	// fiche l'est déjà, pour afficher sa valeur. Le serveur contrôle la
	// clôture pour tous, boss compris (manquants_cloture).
	const etatChoices = (
		form !== null && form.atelier.svp
			? ATELIER_ETATS_SVP_CHOICES
			: ATELIER_ETATS_CHOICES
	).filter(
		([value]) =>
			(value !== ATELIER_ETAT_CLOS ||
				(permissions.isBoss && permissions.canClore) ||
				(form !== null && form.atelier.etat === ATELIER_ETAT_CLOS)) &&
			// Revue 30.10 (D1) : « Ok pour facturation » → « En attente de
			// paiement » = droit « facturer_fiche » (serveur : 403).
			!(
				value === ATELIER_ETAT_EN_ATTENTE_PAIEMENT &&
				(atelierInfo.atelier || {}).etat ===
					ATELIER_ETAT_OK_POUR_FACTURATION &&
				!permissions.canFacturer
			),
	)

	const isLoading =
		form === null || fetchAtelierStatus.loading || fetchClientStatus.loading

	// Atelier sauvegardé et pas encore de location liée → on propose de créer
	// une location (payante, pré-remplie si couverture) ou un prêt. Jamais
	// depuis une fiche client de passage ni une fiche svp (entretien interne)
	// — demande Jordan 23.07.2026. Réparation GE-69 comprise (J1, Jordan
	// 12.10) : « Associer un client » d'abord ; refusé aussi par le serveur.
	const locationCreatable =
		form !== null &&
		atelierLocationLinkable(form.atelier) &&
		form.entite.type !== ENTITE_TYPE_CLIENT_PASSAGE &&
		!form.atelier.svp
	const masterLabel = masterEntite.label || "Master"

	// "Générer devis" (déplacé dans le popup Imprimer) : visible seulement s'il
	// n'existe pas déjà de devis.
	const devisAGenerer =
		form !== null &&
		atelierDevisAGenerer(
			form.atelier,
			permissions.canEdit,
			savedFilesByType(ATELIER_FILE_TYPE_DEVIS).length,
		)

	return (
		<div className="atelier-v2" style={generalStyles.page}>
			{/* Largeur max de la fiche : évite l'étalement plein écran sur grand moniteur. */}
			<div style={{ maxWidth: 1600, margin: "0 auto" }}>
				{isLoading && <LoadingCustomModal />}

				{form !== null && (
					<>
						{/* Bannière lecture seule : la fiche est verrouillée par une
					autre session (composant partagé avec dep/location). */}
						{verrou.verrouillee && (
							<BandeauLectureSeule
								detenuePar={verrou.detenuePar}
							/>
						)}
						{!verrou.verrouillee &&
							permissions.ficheCloseVerrouillee && (
								<BandeauFicheClose
									blocsOuverts={
										permissions.canEditBlocs
											? "Commentaires, sous-traitance et e-mails"
											: null
									}
								/>
							)}
						{form.atelier.issue_depannage && (
							<BandeauIssueDepannage
								issue={form.atelier.issue_depannage}
								enCours={permissions.fournituresEnCours}
								peutBasculer={
									!verrou.verrouillee &&
									!permissions.ficheCloseVerrouillee
								}
								onBasculer={() => setBascule(true)}
							/>
						)}
						{bascule && (
							<ModalBasculeClient
								atelierId={form.atelier.id}
								contact={
									(form.atelier.issue_depannage || {})
										.contact || null
								}
								travailNonEnregistre={travailNonEnregistre()}
								onClose={() => setBascule(false)}
								onFait={() => {
									setBascule(false)
									setReloadCounter((c) => c + 1)
								}}
							/>
						)}
						{/* Header (Phase 1 : titre + n° + badge état + sauts dep/location) */}
						<div style={generalStyles.header}>
							<div>
								<div style={generalStyles.ficheNumber}>
									{form.atelier.id
										? `Fiche atelier #${form.atelier.id}`
										: "Nouvelle fiche"}
								</div>
								<div style={generalStyles.title}>
									{Number.isInteger(form.atelier.id)
										? "Éditer fiche d'atelier"
										: "Nouvelle fiche d'atelier"}
								</div>
								{/* Cadenas : affiché UNIQUEMENT quand la fiche est verrouillée
							    par une autre session — cliquer demande la main au détenteur.
							    Plus de pendant « ouvert vert » : il servait à fermer la fiche,
							    or il n'y a plus de rituel de fermeture (on quitte, le verrou
							    se libère, le slice garde l'id pour le bouton nav « Fiche »). */}
								{Number.isInteger(form.atelier.id) &&
									verrou.verrouillee && (
										<BoutonDemanderMain
											detenuePar={verrou.detenuePar}
											onClick={verrou.demanderLaMain}
										/>
									)}
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 10,
								}}
							>
								{Number.isInteger(form.atelier.id) &&
									form.atelier.dep > 0 && (
										<button
											type="button"
											title={
												`Dépannage N° ${form.atelier.dep}` +
												marqueurFicheLiee(
													atelierInfo.soldesLiees,
													"depannage",
													form.atelier.dep,
												).titre
											}
											style={
												marqueurFicheLiee(
													atelierInfo.soldesLiees,
													"depannage",
													form.atelier.dep,
												).style
											}
											onClick={() =>
												history.push(
													`/depannage/fiche/${form.atelier.dep}`,
												)
											}
										>
											<FontAwesomeIcon
												icon={faTruckPickup}
											/>
										</button>
									)}
								{Number.isInteger(form.atelier.id) &&
									form.atelier.location > 0 && (
										<button
											type="button"
											title={
												`Location N° ${form.atelier.location}` +
												marqueurFicheLiee(
													atelierInfo.soldesLiees,
													"location",
													form.atelier.location,
												).titre
											}
											style={
												marqueurFicheLiee(
													atelierInfo.soldesLiees,
													"location",
													form.atelier.location,
												).style
											}
											onClick={() =>
												history.push(
													`/location/fiche/${form.atelier.location}`,
												)
											}
										>
											<FontAwesomeIcon icon={faCar} />
										</button>
									)}
								{/* Badge état + badge stock + Boss en ligne */}
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										alignItems: "center",
										flexWrap: "wrap",
										gap: 8,
									}}
								>
									{headerBadge}
									{stockBadge}
									{permissions.isBoss &&
										!form.atelier.svp && (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													gap: 8,
												}}
											>
												<FontAwesomeIcon
													icon={faCrown}
													title="Boss"
													style={{
														fontSize: 14,
														color: form.atelier.boss
															? COLORS.gold
															: COLORS.textLight,
														transition:
															"color 0.15s",
													}}
												/>
												<Switch
													on={form.atelier.boss}
													disabled={
														!permissions.canEdit
													}
													title="Boss"
													color={COLORS.success}
													onClick={() =>
														updateAtelier(
															"boss",
															!form.atelier.boss,
														)
													}
												/>
											</div>
										)}
								</div>
								{Number.isInteger(form.atelier.id) && (
									<QRCodeSVG
										value={qrUrl}
										size={72}
										title="Ouvrir dans SvpMobile"
									/>
								)}
							</div>
						</div>

						{/* Bloc Infos de base : rail de référence (client + véhicule, lecture
					    seule) à gauche, carte fiche éditable à droite */}
						<div
							style={{
								display: "grid",
								gridTemplateColumns: hasVehiculeDocs
									? "minmax(300px, 360px) 1fr minmax(300px, 456px)"
									: "minmax(300px, 360px) 1fr",
								gap: 16,
								marginBottom: 16,
								// stretch : la carte de référence (Client+Véhicule) et la
								// carte « Informations fiche » prennent la même hauteur.
								alignItems: "stretch",
							}}
						>
							{/* Carte de référence fusionnée : Client + Véhicule (lecture seule) */}
							<AtelierClientVehiculeCardV2
								entite={form.entite}
								vehicule={vehiculeSelectionne}
								isSvp={form.atelier.svp}
								partieLabel={partieLabel}
								adresse={adresseMemo}
								onVoirVehicule={
									form.atelier.svp &&
									hasRight("vehicule_fiche_entretien")
										? ouvrirVehicule
										: null
								}
								// GE-67 (Jordan 11.10) : toute fiche en client de
								// passage (vente rapide comprise) ; la fiche issue
								// d'un dépannage garde le bouton de son bandeau.
								onAssocierClient={
									peutAssocierClientCarte(
										form,
										verrou.verrouillee,
									) && !permissions.ficheCloseVerrouillee
										? () => setBascule(true)
										: null
								}
								onVoirClient={
									![
										ENTITE_TYPE_MASTER,
										ENTITE_TYPE_CLIENT_PASSAGE,
									].includes(form.entite.type) &&
									form.atelier.entite
										? () =>
												history.push(
													`/clients/${form.atelier.entite}`,
												)
										: null
								}
							/>

							{/* Carte infos fiche (éditable) */}
							<div
								style={{
									...generalStyles.card,
									height: "100%",
								}}
							>
								<div style={generalStyles.cardTitle}>
									Informations fiche
								</div>
								<div style={generalStyles.fieldGroup}>
									<Field label={"Date"}>
										<InputV2
											ref={refDateFiche}
											nextRef={refEtat}
											type="date"
											value={dateFrToISO(
												form.atelier.date,
											)}
											style={generalStyles.input}
											disabled={!permissions.canEdit}
											onChange={(e) =>
												updateAtelier(
													"date",
													dateISOToFr(e.target.value),
												)
											}
										/>
									</Field>
									<Field label={"État"}>
										<SelectV2
											ref={refEtat}
											prevRef={refDateFiche}
											nextRef={refMecanicien}
											value={form.atelier.etat}
											style={generalStyles.select}
											disabled={!permissions.canEditEtat}
											onChange={(e) =>
												updateAtelier(
													"etat",
													parseInt(e.target.value),
												)
											}
										>
											{etatChoices.map(
												([value, label], i) => (
													<option
														key={`etat_${i}`}
														value={value}
													>
														{label}
													</option>
												),
											)}
										</SelectV2>
									</Field>
									{/* GE-48 : posée par le serveur au dernier passage en
								    « Travaux terminés », lecture seule. */}
									<Field label={"Travaux terminés le"}>
										<span
											style={generalStyles.inputReadonly}
										>
											{form.atelier
												.date_travaux_termines || "—"}
										</span>
									</Field>
									{/* Mécanicien : AUSSI pour les fiches client de passage
								    (fix 23.07 — le champ était masqué mais checkFiche
								    l'exige au-delà de Devis accepté : fiche bloquée). */}
									<Field label={"Mécanicien"}>
										<SelectV2
											ref={refMecanicien}
											prevRef={refEtat}
											nextRef={
												!form.atelier.svp &&
												!isVenteRapide
													? refKms
													: undefined
											}
											value={form.atelier.employe}
											style={generalStyles.select}
											disabled={!permissions.canEdit}
											onChange={(e) =>
												updateAtelier(
													"employe",
													parseInt(e.target.value),
												)
											}
										>
											<option value={0}>-</option>
											{filterEmployesGroupe(
												employes,
												form.atelier.employe,
											).map((emp) => (
												<option
													key={`emp_${emp.id}`}
													value={emp.id}
												>
													{emp.nom}
												</option>
											))}
										</SelectV2>
									</Field>
									{/* Fiche d'entretien (svp) : kilométrage du véhicule (obligatoire pour
								    clore ; reporté sur le véhicule à la clôture). Les « prochains
								    travaux » sont pilotés par le cycle d'entretien, pas ici.
								    Une fiche svp vise la flotte master, jamais un client passage. */}
									{form.atelier.svp && (
										<Field label={"Kms"}>
											<InputV2
												ref={refKms}
												prevRef={refMecanicien}
												type="text"
												value={form.atelier.kms}
												style={generalStyles.input}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"kms",
														e.target.value,
													)
												}
											/>
										</Field>
									)}
									{!isVenteRapide && !form.atelier.svp && (
										<>
											<Field label={"Kms"}>
												<InputV2
													ref={refKms}
													prevRef={refMecanicien}
													nextRef={refDateProchain}
													type="text"
													value={form.atelier.kms}
													style={generalStyles.input}
													disabled={
														!permissions.canEdit
													}
													onChange={(e) =>
														updateAtelier(
															"kms",
															e.target.value,
														)
													}
												/>
											</Field>
											<Field
												label={"Date prochains travaux"}
											>
												<InputV2
													ref={refDateProchain}
													prevRef={refKms}
													nextRef={refKmsProchain}
													type="date"
													value={dateFrToISO(
														form.atelier
															.date_prochain_travaux,
													)}
													style={generalStyles.input}
													disabled={
														!permissions.canEdit
													}
													onChange={(e) =>
														updateAtelier(
															"date_prochain_travaux",
															dateISOToFr(
																e.target.value,
															),
														)
													}
												/>
											</Field>
											<Field
												label={"Kms prochains travaux"}
											>
												<InputV2
													ref={refKmsProchain}
													prevRef={refDateProchain}
													type="text"
													value={
														form.atelier
															.kms_prochain_travaux
													}
													style={generalStyles.input}
													disabled={
														!permissions.canEdit
													}
													onChange={(e) =>
														updateAtelier(
															"kms_prochain_travaux",
															e.target.value,
														)
													}
												/>
											</Field>
											<Toggler
												label={"Assurance"}
												on={form.atelier.isAssurance}
												disabled={
													!permissions.canEditFinancier
												}
												onClick={onClickAssurance}
											/>
										</>
									)}
								</div>
							</div>

							{/* Carte Documents véhicule (lecture seule) : photos +
						    carte grise du véhicule, seulement s'il y en a. */}
							{hasVehiculeDocs && (
								<AtelierVehiculeDocumentsCardV2
									vehicule={vehiculeSelectionne}
								/>
							)}
						</div>

						{/* Bloc Assurance (Phase 3) */}
						{form.atelier.isAssurance && (
							<CollapsibleCardV2
								title="Assurance"
								completed={assurancePaneCompleted}
							>
								<div style={generalStyles.grid2}>
									<div style={generalStyles.fieldGroup}>
										<AssuranceSelectV2
											label={"Assurance"}
											value={form.atelier.assurance}
											assurances={assurances}
											disabled={!permissions.canEdit}
											selectRef={refAssurance}
											nextRef={refAudatex}
											onChange={(v) =>
												updateAtelier("assurance", v)
											}
										/>
										<Field
											label={"Audatex / Photo facture"}
										>
											<SelectV2
												ref={refAudatex}
												prevRef={refAssurance}
												nextRef={
													form.atelier
														.audatexPhotoFacture ===
													ATELIER_AUDATEX
														? refExpert
														: refAfterExpert
												}
												value={
													form.atelier
														.audatexPhotoFacture
												}
												style={generalStyles.select}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"audatexPhotoFacture",
														parseInt(
															e.target.value,
														),
													)
												}
											>
												<option value={0}>-</option>
												<option value={ATELIER_AUDATEX}>
													Audatex
												</option>
												<option
													value={
														ATELIER_PHOTO_FACTURE
													}
												>
													Photo facture
												</option>
											</SelectV2>
										</Field>
										{form.atelier.audatexPhotoFacture ===
											ATELIER_AUDATEX && (
											<Field label={"Expert"}>
												<FilteredSelectV2
													options={expertOptions}
													value={
														form.atelier.expertNom
													}
													defaultKey="label"
													optionKeys={[
														"label",
														"entite",
													]}
													minChars={2}
													placeholder="Rechercher un expert…"
													inputRef={refExpert}
													nextRef={refAfterExpert}
													disabled={
														!permissions.canEdit
													}
													onChange={(v) => {
														if (
															form.atelier
																.expert > 0
														)
															updateAtelier(
																"expert",
																0,
															)
														updateAtelier(
															"expertNom",
															v,
														)
													}}
													onSelect={(o) => {
														updateAtelier(
															"expert",
															o ? o.id : 0,
														)
														updateAtelier(
															"expertNom",
															o ? o.label : "",
														)
													}}
													adornment={
														form.atelier.expert >
														0 ? (
															<span
																style={{
																	width: 8,
																	height: 8,
																	borderRadius: 99,
																	backgroundColor:
																		COLORS.success,
																	boxShadow: `0 0 0 3px ${COLORS.successLight}`,
																}}
															/>
														) : null
													}
												/>
											</Field>
										)}
										<Field label={"N° sinistre"}>
											<InputV2
												type="text"
												ref={refAfterExpert}
												prevRef={
													form.atelier
														.audatexPhotoFacture ===
													ATELIER_AUDATEX
														? refExpert
														: refAudatex
												}
												nextRef={refFranchise}
												value={
													form.atelier.numeroSinistre
												}
												style={generalStyles.input}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"numeroSinistre",
														e.target.value,
													)
												}
											/>
										</Field>
										<Field label={"Franchise"}>
											<InputV2
												type="text"
												ref={refFranchise}
												prevRef={refAfterExpert}
												nextRef={refRabaisFranchise}
												value={form.atelier.franchise}
												style={generalStyles.input}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"franchise",
														e.target.value,
													)
												}
											/>
										</Field>
										<Field label={"Rabais franchise"}>
											<InputV2
												type="text"
												ref={refRabaisFranchise}
												prevRef={refFranchise}
												nextRef={refCouverture}
												value={
													form.atelier.rabaisFranchise
												}
												style={generalStyles.input}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"rabaisFranchise",
														e.target.value,
													)
												}
											/>
										</Field>
										<Field label={"Couverture location"}>
											<SelectV2
												ref={refCouverture}
												prevRef={refRabaisFranchise}
												nextRef={
													form.atelier
														.isCouvertLocation === 1
														? refAssuranceLocation
														: refRemarques
												}
												value={
													form.atelier
														.isCouvertLocation
												}
												style={generalStyles.select}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"isCouvertLocation",
														parseInt(
															e.target.value,
														),
													)
												}
											>
												<option value={0}>Non</option>
												<option value={1}>Oui</option>
											</SelectV2>
										</Field>
									</div>
									<div style={generalStyles.fieldGroup}>
										{/* Remarques : label aligné en haut, textarea qui
									    remplit toute la hauteur de la colonne. */}
										<div
											style={{
												display: "flex",
												alignItems: "flex-start",
												gap: 8,
												flex: 1,
											}}
										>
											<span style={generalStyles.label}>
												Remarques
											</span>
											<textarea
												ref={refRemarques}
												value={
													form.atelier
														.assuranceRemarques
												}
												style={{
													...generalStyles.input,
													flex: 1,
													alignSelf: "stretch",
													minHeight: 90,
													resize: "vertical",
												}}
												disabled={!permissions.canEdit}
												onChange={(e) =>
													updateAtelier(
														"assuranceRemarques",
														e.target.value,
													)
												}
											/>
										</div>
									</div>
								</div>

								{/* Infos location (si couverture location) */}
								{form.atelier.isCouvertLocation === 1 && (
									<div style={generalStyles.mt18}>
										<div style={generalStyles.cardTitle}>
											Informations location
										</div>
										<div style={generalStyles.grid2}>
											<div
												style={generalStyles.fieldGroup}
											>
												<AssuranceSelectV2
													label={"Assurance location"}
													value={
														form.atelier
															.assuranceLocation
													}
													assurances={assurances}
													disabled={
														!permissions.canEdit
													}
													selectRef={
														refAssuranceLocation
													}
													prevRef={refCouverture}
													nextRef={refRefLocation}
													onChange={(v) =>
														updateAtelier(
															"assuranceLocation",
															v,
														)
													}
												/>
												<Field label={"N° référence"}>
													<InputV2
														type="text"
														ref={refRefLocation}
														prevRef={
															refAssuranceLocation
														}
														nextRef={refNbJours}
														value={
															form.atelier
																.refLocation
														}
														style={
															generalStyles.input
														}
														disabled={
															!permissions.canEdit
														}
														onChange={(e) =>
															updateAtelier(
																"refLocation",
																e.target.value,
															)
														}
													/>
												</Field>
											</div>
											<div
												style={generalStyles.fieldGroup}
											>
												<Field label={"Nb jours"}>
													<InputV2
														type="text"
														ref={refNbJours}
														prevRef={refRefLocation}
														nextRef={refTarifJours}
														value={
															form.atelier
																.nbJoursLocation
														}
														style={
															generalStyles.input
														}
														disabled={
															!permissions.canEdit
														}
														onChange={(e) =>
															updateAtelier(
																"nbJoursLocation",
																e.target.value,
															)
														}
													/>
												</Field>
												<Field label={"Tarif par jour"}>
													<InputV2
														type="text"
														ref={refTarifJours}
														prevRef={refNbJours}
														nextRef={refRemarques}
														value={
															form.atelier
																.tarifJoursLocation
														}
														style={
															generalStyles.input
														}
														disabled={
															!permissions.canEdit
														}
														onChange={(e) =>
															updateAtelier(
																"tarifJoursLocation",
																e.target.value,
															)
														}
													/>
												</Field>
											</div>
										</div>
									</div>
								)}

								{/* Sections fichiers (avant / après / calcul / bulletins) */}
								<div style={generalStyles.mt18}>
									<div style={generalStyles.cardTitle}>
										Fichiers
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											gap: 24,
										}}
									>
										{[
											{
												title: "Photos avant réparation",
												type: ATELIER_FILE_TYPE_AVANT_REPARATION,
											},
											{
												title: "Photos après réparation",
												type: ATELIER_FILE_TYPE_APRES_REPARATION,
											},
											{
												title: "Calcul des réparations",
												type: ATELIER_FILE_TYPE_CALCUL_REPARATION,
											},
											{
												title: "Bulletins de livraison / Pièces",
												type: ATELIER_FILE_TYPE_BULLETIN_LIVRAISON,
											},
										].map((section) => (
											<FileSection
												key={`filesection_${section.type}`}
												title={section.title}
												type={section.type}
												savedFiles={savedFilesByType(
													section.type,
												)}
												pending={pendingByType(
													section.type,
												)}
												onAdd={addPendingFiles}
												deleteFile={deleteFileDispatch}
												postDelete={
													atelierInfo.deleteAtelierFile
												}
												resetDelete={resetDeleteFile}
												canEdit={permissions.canEdit}
											/>
										))}
									</div>
									<button
										type="button"
										style={{
											...generalStyles.btnSecondary,
											marginTop: 12,
										}}
										onClick={postFiles}
										disabled={
											pendingFiles.length === 0 ||
											!permissions.canEdit ||
											!ficheEnregistree ||
											(atelierInfo.postAtelierFiles &&
												atelierInfo.postAtelierFiles
													.saving)
										}
									>
										{atelierInfo.postAtelierFiles &&
										atelierInfo.postAtelierFiles.saving
											? "Upload en cours…"
											: "Uploader"}
									</button>
								</div>

								{/* Bouton PDF fiche réparation assurance */}
								{form.atelier.etat >=
									ATELIER_ETAT_A_RESTITUER && (
									<div style={generalStyles.mt18}>
										<AppBtnDownloadPdf
											style={generalStyles.btnSecondary}
											btnTitle={
												"Fiche de réparation assurance"
											}
											apiRoute={`api/pdf?id=${form.atelier.id}&type=atelier&pdf_type=reparation_assurance`}
											disabled={
												form.atelier.assurance === 0 ||
												form.atelier.numeroSinistre ===
													"" ||
												(form.atelier.expert === 0 &&
													form.atelier
														.audatexPhotoFacture ===
														ATELIER_AUDATEX)
											}
										/>
									</div>
								)}
							</CollapsibleCardV2>
						)}

						{/* Bloc Travaux (Phase 4.2) — masqué en « devis à faire » */}
						{!isDevisAFaire && (
							<CollapsibleCardV2
								title="Travaux"
								right={
									permissions.canEditFinancier &&
									accessModules.includes(
										"atelier_modeles",
									) ? (
										<button
											type="button"
											style={generalStyles.btnSecondary}
											onClick={() => {
												dispatch(fetchAtelierModeles())
												setModeleModal(true)
											}}
										>
											Appliquer un modèle
										</button>
									) : null
								}
							>
								{[
									{
										title: "Main d'œuvre",
										type: ATELIER_LIGNE_TYPE_MAIN_OEUVRE,
										idname: "mo",
										show: true,
									},
									{
										title: "Fournitures",
										type: ATELIER_LIGNE_TYPE_FOURNITURE,
										idname: "fo",
										show: true,
									},
									{
										title: "Autres",
										type: ATELIER_LIGNE_TYPE_AUTRE,
										idname: "au",
										show: true,
									},
									{
										title: "Prestations supplémentaires",
										type: ATELIER_LIGNE_TYPE_SUPPLEMENTAIRE,
										idname: "supp",
										show:
											form.atelier.etat ===
											ATELIER_ETAT_EN_ATTENTE_PAIEMENT,
									},
								]
									.filter((s) => s.show)
									.map((section) => (
										<TravauxSection
											key={`travaux_${section.idname}`}
											section={section}
											lignes={form.atelierLignes.filter(
												(l) => l.type === section.type,
											)}
											atelier={form.atelier}
											isSVP={form.atelier.svp}
											canEdit={
												permissions.canEditFinancier
											}
											updateAtelierLignes={
												updateAtelierLignes
											}
											replaceLigne={replaceLigne}
											removeAtelierLignes={
												removeAtelierLignes
											}
											onModifierPrix={
												setModifierPrixLigne
											}
											onAddLigne={addAtelierLignes}
											onReorder={reorderLignes}
											onSousTraitant={() =>
												setSousTraitantsModal(true)
											}
											onInventaire={openInventaireModal}
										/>
									))}
							</CollapsibleCardV2>
						)}

						{/* Bloc Commentaires séparé (Phase 4.3) */}
						<CollapsibleCardV2 title="Commentaires">
							{[
								{
									title: "Commentaires client",
									print: true,
								},
								{
									title: "Notes internes",
									print: false,
								},
							].map((section) => {
								const comments =
									form.atelierCommentaires.filter(
										(c) => c.print === section.print,
									)
								return (
									<div
										key={`com_${section.print}`}
										style={generalStyles.mt18}
									>
										<div
											style={{
												fontSize: 12,
												fontWeight: 600,
												color: COLORS.text,
												marginBottom: 8,
											}}
										>
											{section.title}
										</div>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												gap: 8,
											}}
										>
											{comments.map((comment) => (
												<CommentRow
													key={`com_${comment.id}`}
													comment={comment}
													onUpdate={
														updateAtelierCommentaires
													}
													onRemove={
														removeAtelierCommentaires
													}
													disabled={
														!permissions.canEditBlocs
													}
												/>
											))}
										</div>
										{permissions.canEditBlocs && (
											<button
												type="button"
												style={{
													...generalStyles.addBtn,
													marginTop: 10,
												}}
												onClick={() =>
													addAtelierCommentaires(
														section.print,
													)
												}
											>
												<FontAwesomeIcon
													icon={faPlus}
												/>
												{section.print
													? "Ajouter un commentaire"
													: "Ajouter une note"}
											</button>
										)}
									</div>
								)
							})}
						</CollapsibleCardV2>

						{/* Blocs masqués en « devis à faire » (Totaux → Transactions) */}
						{!isDevisAFaire && (
							<>
								{/* Bloc Totaux (Phase 5) */}
								<CollapsibleCardV2 title="Totaux">
									<div
										style={{
											display: "grid",
											gridTemplateColumns:
												"repeat(auto-fit, minmax(170px, 1fr))",
											gap: 12,
											justifyContent: "center",
											alignItems: "stretch",
										}}
									>
										{/* Totaux HT + TVA */}
										{!form.atelier.svp && (
											<div style={generalStyles.statCard}>
												<span
													style={
														generalStyles.statLabel
													}
												>
													Total travaux HT
												</span>
												<span
													style={
														generalStyles.statValue
													}
												>
													{round100(totaux.sousTotHT)}
												</span>
												<span
													style={
														generalStyles.statSub
													}
												>
													TVA {form.atelier.tva}% :{" "}
													{round100(totaux.totTva)}
												</span>
											</div>
										)}

										{/* Rabais */}
										{!form.atelier.svp &&
											!isVenteRapide && (
												<div
													style={
														generalStyles.statCard
													}
												>
													<span
														style={
															generalStyles.statLabel
														}
													>
														Rabais HT
													</span>
													<span
														style={
															generalStyles.statValue
														}
													>
														{round100(
															totaux.rabaisHT,
														)}
													</span>
													<span
														style={
															generalStyles.statSub
														}
													>
														{round100(
															totaux.rabaisPc,
														)}{" "}
														%
													</span>
												</div>
											)}

										{/* Marge (boss / chef atelier) */}
										{permissions.canSeeChefAtelier &&
											!form.atelier.svp &&
											!isVenteRapide && (
												<div
													style={
														generalStyles.statCard
													}
												>
													<span
														style={
															generalStyles.statLabel
														}
													>
														Marge HT
													</span>
													<span
														style={
															generalStyles.statValue
														}
													>
														{round100(totaux.marge)}
													</span>
													<span
														style={
															generalStyles.statSub
														}
													>
														{round100(
															totaux.margePc,
														)}{" "}
														%
													</span>
												</div>
											)}

										{/* Total achat HT */}
										{permissions.canSeeChefAtelier &&
											!form.atelier.svp && (
												<div
													style={
														generalStyles.statCard
													}
												>
													<span
														style={
															generalStyles.statLabel
														}
													>
														Total achat HT
													</span>
													<span
														style={
															generalStyles.statValue
														}
													>
														{round100(
															totaux.totAchat,
														)}
													</span>
												</div>
											)}

										{/* Total final TTC (ou coût entretien si SVP) */}
										<div
											style={{
												...generalStyles.totalHighlight,
											}}
										>
											<span
												style={{
													...generalStyles.statLabel,
													color: "rgba(255,255,255,0.7)",
												}}
											>
												{form.atelier.svp
													? "Coût entretien HT"
													: "Total final TTC"}
											</span>
											<span
												style={{
													...generalStyles.statValue,
													color: "#fff",
												}}
											>
												{form.atelier.svp
													? totaux.coutEntretienTTC
													: round20(totaux.totalTTC)}
											</span>
										</div>
									</div>
								</CollapsibleCardV2>

								{/* Bloc Sous-traitance (Phase 9) */}
								{sousTraitantsMerged.length > 0 && (
									<CollapsibleCardV2 title="Sous-traitance">
										{sousTraitantsMerged.map(
											(st, index) => (
												<AtelierSousTraitantV2
													key={`st_${st.sousTraitant}`}
													sousTraitant={st}
													index={index}
													updateSousTraitant={
														updateSousTraitant
													}
													tva={form.atelier.tva}
													locked={
														!permissions.canEditBlocs
													}
												/>
											),
										)}
									</CollapsibleCardV2>
								)}

								{/* Documents / Restitution / E-mails sur une même ligne (flex:1
					    chacun ; ordre d'affichage forcé via `order`). */}
								<div
									style={{
										display: "flex",
										gap: 16,
										alignItems: "flex-start",
										marginBottom: 16,
									}}
								>
									{/* Bloc Documents (Phase 10). Fiches master/entretien (svp) :
					    uniquement la section « Autres » — pas de devis ni de
					    photos pièces sur les fiches internes. */}
									{form.atelier.id && (
										<CollapsibleCardV2
											title="Documents"
											defaultOpen={false}
											style={{
												flex: 1,
												minWidth: 0,
												marginBottom: 0,
												order: 0,
											}}
										>
											<div
												style={{
													display: "flex",
													flexDirection: "column",
													gap: 24,
												}}
											>
												{!form.atelier.svp && (
													<FileSection
														title="Devis"
														type={
															ATELIER_FILE_TYPE_DEVIS
														}
														savedFiles={savedFilesByType(
															ATELIER_FILE_TYPE_DEVIS,
														)}
														pending={[]}
														onAdd={addPendingFiles}
														deleteFile={
															deleteFileDispatch
														}
														postDelete={
															atelierInfo.deleteAtelierFile
														}
														resetDelete={
															resetDeleteFile
														}
														canEdit={
															permissions.canEdit
														}
														readOnly
													/>
												)}
												{(form.atelier.svp
													? [
															{
																title: "Autres",
																type: ATELIER_FILE_TYPE_AUTRE,
															},
														]
													: [
															{
																title: "Devis signé",
																type: ATELIER_FILE_TYPE_DEVIS_SIGNE,
															},
															{
																title: "Photos pièces",
																type: ATELIER_FILE_TYPE_PHOTO_PIECE,
															},
															{
																title: "Autres",
																type: ATELIER_FILE_TYPE_AUTRE,
															},
														]
												).map((section) => (
													<FileSection
														key={`doc_${section.type}`}
														title={section.title}
														type={section.type}
														savedFiles={savedFilesByType(
															section.type,
														)}
														pending={pendingByType(
															section.type,
														)}
														onAdd={addPendingFiles}
														deleteFile={
															deleteFileDispatch
														}
														postDelete={
															atelierInfo.deleteAtelierFile
														}
														resetDelete={
															resetDeleteFile
														}
														canEdit={
															permissions.canEdit
														}
													/>
												))}
											</div>
											<button
												type="button"
												style={{
													...generalStyles.btnSecondary,
													marginTop: 12,
												}}
												onClick={postFiles}
												disabled={
													pendingFiles.length === 0 ||
													!permissions.canEdit ||
													!ficheEnregistree ||
													(atelierInfo.postAtelierFiles &&
														atelierInfo
															.postAtelierFiles
															.saving)
												}
											>
												{atelierInfo.postAtelierFiles &&
												atelierInfo.postAtelierFiles
													.saving
													? "Upload en cours…"
													: "Uploader"}
											</button>
										</CollapsibleCardV2>
									)}

									{/* Bloc E-mails (Phase 11) */}
									{form.atelier.id &&
										!form.atelier.svp &&
										((form.atelier.etat >=
											ATELIER_ETAT_TRAVAUX_EN_COURS &&
											form.atelier.expert !== 0) ||
											form.atelier.etat >=
												ATELIER_ETAT_EN_ATTENTE_CLIENT ||
											(form.atelier.isAssurance &&
												form.atelier.etat >=
													ATELIER_ETAT_OK_POUR_FACTURATION)) && (
											<CollapsibleCardV2
												title="E-mails"
												defaultOpen={false}
												style={{
													flex: 1,
													minWidth: 0,
													marginBottom: 0,
													order: 2,
												}}
											>
												<EmailListV2 emails={emails} />
												{permissions.canEditBlocs && (
													<button
														type="button"
														style={
															generalStyles.btnSecondary
														}
														onClick={() =>
															setShowModalEmail(
																true,
															)
														}
													>
														Nouvel e-mail
													</button>
												)}
											</CollapsibleCardV2>
										)}

									{/* Bloc Restitution (Phase 6) */}
									{form.atelier.etat >=
										ATELIER_ETAT_A_RESTITUER &&
										form.atelier.isAssurance && (
											<CollapsibleCardV2
												title="Restitution"
												status={restitutionStatus}
												style={{
													flex: 1,
													minWidth: 0,
													marginBottom: 0,
													order: 1,
												}}
											>
												<div
													style={
														generalStyles.fieldGroup
													}
												>
													{form.entite.type ===
														ENTITE_TYPE_SOCIETE && (
														<Field
															label={
																"Représenté par"
															}
														>
															<input
																type="text"
																style={
																	generalStyles.input
																}
																value={
																	form.atelier
																		.represente_par
																}
																disabled={
																	!permissions.canEdit
																}
																onChange={(e) =>
																	updateAtelier(
																		"represente_par",
																		e.target
																			.value,
																	)
																}
															/>
														</Field>
													)}

													{/* Générer document : sauve puis télécharge le PDF restitution.
									    Société sans « Représenté par » → popup explicatif. */}
													<button
														type="button"
														style={
															generalStyles.btnSecondary
														}
														onClick={() => {
															if (
																form.entite
																	.type ===
																	ENTITE_TYPE_SOCIETE &&
																form.atelier
																	.represente_par ===
																	""
															) {
																setRepresenteParModal(
																	true,
																)
																return
															}
															save(() =>
																downloadAtelierPdf(
																	"restitution",
																),
															)
														}}
														disabled={
															!permissions.canEdit
														}
													>
														Générer le document
													</button>

													{/* Document signé : upload 1-clic + suppression (confirmation interne PdfSlot) */}
													<PdfSlot
														label="Document signé"
														doc={
															atelier.doc_restitution &&
															atelier
																.doc_restitution
																.saved
																? normalizePdf(
																		atelier.doc_restitution,
																	)
																: null
														}
														onUpload={(
															normalizedPdf,
														) =>
															uploadDocRestitution(
																normalizedPdf.file,
															)
														}
														onDelete={
															deleteDocRestitution
														}
														readOnly={
															!permissions.canEdit ||
															!ficheEnregistree
														}
													/>
												</div>
											</CollapsibleCardV2>
										)}
								</div>

								{/* Bloc Heures de travail (Phase 7) — composant existant, géré via redux */}
								{carteHeuresAffichee && (
									<CollapsibleCardV2
										title="Heures de travail"
										completed={heuresCompletes}
									>
										<AtelierFicheHeuresV2
											isDisabled={
												!permissions.canEditFinancier
											}
										/>
									</CollapsibleCardV2>
								)}

								{/* Bloc Transactions (Phase 8) — condition hoistée
							    (showTransactionsCard), cf. commentaire à sa
							    déclaration. Carte partagée avec dep/location
							    (others/TransactionsCardV2, modèle atelier). */}
								{showTransactionsCard && (
									<TransactionsCardV2
										transactions={
											form.atelier.transactionsv2
										}
										restePayer={restePayer}
										// Jordan 19.10 : en Clos, la règle des
										// transactions (boss seulement) plutôt
										// que canEditFinancier.
										canEdit={permissions.canEdit}
										locked={ficheClose && niveau !== BOSS}
										nonSupprimable={(tx) =>
											causeNonSupprimable(
												avecServeur(
													tx,
													transactionsServeur,
												),
												{ niveau },
											)
										}
										datation={(tx) =>
											regleDatation(
												avecServeur(
													tx,
													transactionsServeur,
												),
												{
													droitEncaissements:
														hasRight(
															"dater_transactions",
														),
													niveau,
													mdpFactureId: mdpFacture
														? mdpFacture.id
														: 0,
												},
											)
										}
										champs={(tx) =>
											champsModifiables(
												avecServeur(
													tx,
													transactionsServeur,
												),
												{ niveau },
											)
										}
										onAdd={() =>
											setAddTransactionModal(true)
										}
										addDisabled={restePayer === 0}
										onChange={(idx, key, value) =>
											updateTransactions(key, value, idx)
										}
										onDelete={(idx) =>
											removeTransaction(
												form.atelier.transactionsv2[idx]
													.id,
											)
										}
										onDeleteDocument={deleteTransactionDoc}
										onGenerate={generateQuittance}
										onUploadFacture={
											uploadTransactionFacture
										}
										module="ate"
										entite={form.entite}
									/>
								)}
								{/* Notes système (Jordan 19.10) : boss seulement ;
								    relues après chaque save (heures = réponse du
								    serveur, POST_ATELIER_SUCCESS). */}
								<HistoriqueCardV2
									domaine="atelier"
									objetId={form.atelier.id}
									rafraichir={atelierInfo.heures}
								/>
							</>
						)}

						{/* Footer : actions selon l'état + droits. En Clos, canEdit
					    reste vrai (édition partielle) donc les gardes par bouton
					    décident individuellement de la visibilité. */}
						<div style={{ height: 60 }} />
						<div style={generalStyles.fixedFooter}>
							{/* Créer une fiche location (payante ou prêt) depuis
						    l'atelier ; le lien est établi à la sauvegarde de la
						    location. */}
							{permissions.canEdit &&
								locationCreatable &&
								form.atelier.etat !== ATELIER_ETAT_CLOS && (
									<button
										type="button"
										style={generalStyles.btnSecondary}
										onClick={() =>
											setModalCreerLocation(true)
										}
									>
										Créer la location
									</button>
								)}
							{form.atelier.id &&
								!isDevisAFaire &&
								(() => {
									// Imprimer désactivé tant que la fiche a des
									// modifications non enregistrées (le PDF sortirait
									// des données de la base, pas de l'écran).
									const modifiee = ficheModifiee()
									return (
										<button
											type="button"
											style={{
												...generalStyles.btnSecondary,
												...(modifiee
													? {
															opacity: 0.5,
															cursor: "not-allowed",
														}
													: {}),
											}}
											disabled={modifiee}
											onClick={() => setPrintModal(true)}
										>
											Imprimer
										</button>
									)
								})()}
							{permissions.canSave && (
								<button
									type="button"
									style={generalStyles.btnSecondary}
									onClick={() => setModalSave(true)}
								>
									Sauvegarder
								</button>
							)}
							{/* Étape suivante (jusqu'à À restituer) — masquée sur une
						    fiche « Devis refusé » (retour via le sélecteur d'état)
						    et sur une fiche svp « Travaux terminés » sans le droit
						    de clôture (l'étape suivante y est Clos). */}
							{permissions.canEdit &&
								form.atelier.id !== null &&
								form.atelier.etat <= ATELIER_ETAT_A_RESTITUER &&
								form.atelier.etat !==
									ATELIER_ETAT_DEVIS_REFUSE &&
								!(
									form.atelier.svp &&
									form.atelier.etat ===
										ATELIER_ETAT_TRAVAUX_TERMINES &&
									!permissions.canClore
								) && (
									<button
										type="button"
										style={generalStyles.btnPrimary}
										onClick={() =>
											form.atelier.etat ===
											ATELIER_ETAT_A_RESTITUER
												? withLocationRestitue(() =>
														withDepPaid(() =>
															checkFiche(true),
														),
													)
												: checkFiche(true)
										}
									>
										{form.atelier.etat ===
										ATELIER_ETAT_DEVIS_ACCEPTE
											? "Commencer les travaux"
											: form.atelier.etat ===
												  ATELIER_ETAT_A_RESTITUER
												? "Restituer"
												: "Étape suivante"}
									</button>
								)}
							{/* Contrôle avant facturation */}
							{permissions.canEdit &&
								form.atelier.etat ===
									ATELIER_ETAT_CONTROLE_AVANT_FACTURATION && (
									<button
										type="button"
										style={generalStyles.btnPrimary}
										onClick={() => checkFiche(true)}
									>
										Valider le contrôle
									</button>
								)}
							{/* Facturer (OK pour facturation) */}
							{form.atelier.etat ===
								ATELIER_ETAT_OK_POUR_FACTURATION && (
								<button
									type="button"
									style={
										!permissions.canFacturer
											? generalStyles.btnDisabled
											: generalStyles.btnPrimary
									}
									onClick={() => setFacturationModal(true)}
									disabled={!permissions.canFacturer}
								>
									{transactionsAFacturer().length > 0
										? "Facturer"
										: "En attente paiement"}
								</button>
							)}
							{/* Facture WinBIZ (état 50, tx Facture sans n° ou sans PDF) —
							    COMMENTÉ le 01.10.2026 : WinBIZ en phase de test (en prod,
							    « Créer la facture » écrivait dans le dossier de TEST). À
							    réactiver après le rework, EN MÊME TEMPS que la garde 50→60
							    (settings.WINBIZ_ACTIF = True).
							{form.atelier.etat ===
								ATELIER_ETAT_OK_POUR_FACTURATION &&
								(form.atelier.transactionsv2 || []).some(
									(t) =>
										transactionEstFacture(
											t,
											moyenPaiements,
										) &&
										t.payeParSelect !== PAYE_PAR_MASTER &&
										((!t.extra_data?.winbiz?.numero &&
											!t.extra_data?.winbiz?.manuel) ||
											!t.facture),
								) && (
									<button
										type="button"
										style={
											!permissions.canSeeAdmin
												? generalStyles.btnDisabled
												: generalStyles.btnSecondary
										}
										onClick={() => {
											dispatch(postAtelierReset())
											setSaveNext(false)
											setFactureOnly(true)
											setSaveAtelierModal(true)
										}}
										disabled={!permissions.canSeeAdmin}
									>
										Facture WinBIZ
									</button>
								)}
							*/}
							{/* Clore (en attente paiement) — droit `atelier_cloture`
						    (boss / admin / assistant_admin). La validation se fait au clic. */}
							{form.atelier.etat ===
								ATELIER_ETAT_EN_ATTENTE_PAIEMENT &&
								permissions.canClore && (
									<button
										type="button"
										style={generalStyles.btnPrimary}
										onClick={() => {
											const manquants = []
											const txs =
												form.atelier.transactionsv2 ||
												[]
											if (
												txs.some(
													(t) =>
														!isValidDateUSA(
															t.date,
														) &&
														t.payeParSelect !==
															PAYE_PAR_MASTER,
												)
											)
												manquants.push(
													"la date de paiement d'au moins une transaction",
												)
											if (
												txs.some(
													(t) =>
														transactionEstFacture(
															t,
															moyenPaiements,
														) &&
														t.payeParSelect !==
															PAYE_PAR_MASTER &&
														!t.facture,
												)
											)
												manquants.push(
													"la facture d'au moins une transaction payée par facture",
												)
											if (
												sousTraitantsMerged.length >
													0 &&
												sousTraitantsMerged.some(
													(st) =>
														!isValidDateUSA(
															st.payeLe,
														),
												)
											)
												manquants.push(
													"la date « Payé le » de chaque ligne sous-traitant",
												)
											// Fiche d'entretien (svp) : kilométrage obligatoire
											// (reporté sur le véhicule à la clôture).
											if (
												form.atelier.svp &&
												[
													"0",
													"",
													0,
													null,
													undefined,
												].includes(form.atelier.kms)
											)
												manquants.push(
													"le kilométrage du véhicule",
												)
											if (manquants.length > 0) {
												setCloreManquants(manquants)
												return
											}
											// Débit de stock incomplet : le back
											// refuserait la clôture (400 + rollback)
											// si le stock manque ENCORE. Le flag
											// sérialisé pouvant être périmé
											// (réappro depuis le chargement), on
											// vérifie la dispo en live (alCheck) :
											// dispo revenue → clôture (le POST
											// débite le reliquat), sinon message.
											const lignesStockIncomplet = (
												form.atelierLignes || []
											).filter((l) => l.debit_incomplet)
											if (
												lignesStockIncomplet.length > 0
											) {
												// fetch direct (pas le thunk) : le
												// slice atelierQuantites est partagé
												// avec le popup « Stock insuffisant »
												// de la transition Terminés, qui
												// pop-ait pendant ce check.
												fetch(
													`${URL}api/atelierlignes`,
													{
														method: "PUT",
														headers: {
															Authorization: `Bearer ${token}`,
															"Content-Type":
																"application/json",
														},
														body: JSON.stringify({
															alCheck: [
																...form.atelierLignes,
															],
														}),
													},
												)
													.then((res) => res.json())
													.then((quantites) => {
														if (
															quantites.length ===
															0
														)
															setCloreModal(true)
														else
															setCloreManquants(
																quantites.map(
																	(q) =>
																		`du stock (réapprovisionner) : ${q}`,
																),
															)
													})
													// Check injoignable : on laisse le
													// back trancher (400 affiché dans
													// le modal de clôture si besoin).
													.catch(() =>
														setCloreModal(true),
													)
												return
											}
											setCloreModal(true)
										}}
									>
										Clore
									</button>
								)}
						</div>
					</>
				)}

				{saveAtelierModal && (
					<SaveAtelierV2
						updateEtatAndSave={updateEtatAndSave}
						nextEtat={nextEtat}
						refreshTransactions={refreshTransactions}
						next={saveNext}
						forceDevis={devisOnly}
						factureOnly={factureOnly}
						etat={form.atelier.etat}
						closeModal={() => {
							setSaveAtelierModal(false)
							setDevisOnly(false)
							setFactureOnly(false)
							dispatch(postAtelierReset())
						}}
						mdps={moyenPaiements}
						employes={employes}
						obj={atelierInfo.postAtelier}
						save={save}
						svp={form.atelier.svp}
						setRestitution={setRestitution}
						atelier={form.atelier}
						totClient={totaux ? totaux.totClientTTC : 0}
						totAssurance={totaux ? totaux.totAssTTC : 0}
						totMaster={form.atelier.rabaisFranchise}
						restePayerFacturation={getRestePayerFacturation()}
					/>
				)}

				{(atelierInfo.fetchAtelierQuantites.loading ||
					atelierInfo.atelierQuantites.length > 0) && (
					<AtelierModalQuantitesV2
						fetchAtelierQuantites={
							atelierInfo.fetchAtelierQuantites
						}
						atelierQuantites={atelierInfo.atelierQuantites}
						closeModal={() =>
							dispatch(fetchAtelierQuantitesReset())
						}
					/>
				)}

				{/* Confirmation de sauvegarde (bouton hors modal → CustomModal).
				    Aucun verrou heures ici (supprimé le 31.07) : la sauvegarde
				    n'est jamais bloquée par les heures, seule l'« Étape suivante »
				    les réclame (checkFiche). Une ligne incomplète part au serveur
				    et revient en 400 lisible. */}
				{modalSave && (
					<CustomModal
						title={"Enregistrer les modifications ?"}
						onClose={() => setModalSave(false)}
						showCloseButton={false}
						buttons={[
							{
								title: "Non",
								styleName: "secondary",
								onClick: () => setModalSave(false),
							},
							{
								title: "Oui",
								styleName: "primary",
								onClick: () => {
									setModalSave(false)
									save(null, null, { feedback: true })
								},
							},
						]}
					>
						{/* Jordan 19.10 : conséquences (documents archivés,
						    WinBIZ, rapprochement, fiche close). */}
						{consequencesSave().length > 0 && (
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: 8,
								}}
							>
								{consequencesSave().map((texte) => (
									<span
										key={texte}
										style={{ color: COLORS.danger }}
									>
										<FontAwesomeIcon
											icon={faExclamationTriangle}
											style={{ marginRight: 6 }}
										/>
										{texte}
									</span>
								))}
							</div>
						)}
					</CustomModal>
				)}

				{/* Popup d'impression : choix du modèle PDF. Chaque bouton ferme le
			    popup puis lance le téléchargement via downloadAtelierPdf. */}
				{modalCreerLocation && (
					<CustomModal
						title={"Créer une fiche location"}
						onClose={() => setModalCreerLocation(false)}
						buttons={[
							{
								title: "Location",
								styleName: "primary",
								onClick: () => {
									setModalCreerLocation(false)
									creerLocationDepuisAtelier("location")
								},
							},
							{
								title: "Prêt",
								styleName: "secondary",
								onClick: () => {
									setModalCreerLocation(false)
									creerLocationDepuisAtelier("pret")
								},
							},
						]}
					>
						<p
							style={{
								margin: 0,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							{atelierCouvertureLocationComplete(form.atelier)
								? `Location : fiche payante pré-remplie avec la couverture assurance. Prêt : véhicule prêté, facturation prise en charge par ${masterLabel} (perte interne).`
								: `Location : fiche payante. Prêt : véhicule prêté, facturation prise en charge par ${masterLabel} (perte interne).`}
						</p>
					</CustomModal>
				)}

				{printModal && (
					<CustomModal
						title={"Imprimer"}
						onClose={() => setPrintModal(false)}
						buttons={[
							...(devisAGenerer
								? [
										{
											title: "Générer devis",
											styleName: "secondary",
											onClick: () => {
												setPrintModal(false)
												genererDevis()
											},
										},
									]
								: []),
							{
								title: "Diagnostique",
								styleName: "secondary",
								onClick: () => {
									setPrintModal(false)
									downloadAtelierPdf("diagnostique")
								},
							},
							{
								title: "Fiche de travail",
								styleName: "secondary",
								onClick: () => {
									setPrintModal(false)
									downloadAtelierPdf("fiche_travail")
								},
							},
							{
								title: "Fiche atelier",
								styleName: "primary",
								onClick: () => {
									setPrintModal(false)
									downloadAtelierPdf("fiche")
								},
							},
						]}
					/>
				)}

				{/* Feedback sauvegarde (sauf pendant une transition d'étape ou une clôture :
			    SaveAtelierV2 / AtelierCloreModalV2 affichent déjà leur propre feedback,
			    éviter le double modal). */}
				{representeParModal && (
					<CustomModal
						title={"Champ requis"}
						onClose={() => setRepresenteParModal(false)}
						buttons={[
							{
								title: "Compris",
								styleName: "primary",
								onClick: () => setRepresenteParModal(false),
							},
						]}
					>
						<p
							style={{
								margin: 0,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							Pour une société, le champ « Représenté par » doit
							être rempli avant de générer le document de
							restitution.
						</p>
					</CustomModal>
				)}

				{/* Avertissement : champs manquants au moment de clore la fiche. */}
				{cloreManquants.length > 0 && (
					<CustomModal
						title={"Clôture impossible : informations manquantes"}
						onClose={() => setCloreManquants([])}
						buttons={[
							{
								title: "Compris",
								styleName: "primary",
								onClick: () => setCloreManquants([]),
							},
						]}
					>
						<p
							style={{
								margin: 0,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							Avant de clore la fiche, merci de renseigner :
						</p>
						<ul
							style={{
								margin: "8px 0 0",
								paddingLeft: 18,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							{cloreManquants.map((m, i) => (
								<li key={i}>{m}</li>
							))}
						</ul>
					</CustomModal>
				)}

				{!saveAtelierModal &&
					!cloreModal &&
					(atelierInfo.postAtelier.saving ||
						atelierInfo.postAtelier.saved ||
						atelierInfo.postAtelier.error) && (
						<SavingCustomModal
							post={atelierInfo.postAtelier}
							onClose={() => dispatch(postAtelierReset())}
						/>
					)}

				{modalSwitchAssurance && (
					<AtelierSwitchAssuranceModalV2
						isAssurance={form.atelier.isAssurance}
						selectedAssurance={switchAssuranceSel}
						onSelectAssurance={setSwitchAssuranceSel}
						assurances={assurances}
						onConfirm={() =>
							applyToggleAssurance(
								form.atelier.isAssurance
									? null
									: switchAssuranceSel,
							)
						}
						onClose={() => setModalSwitchAssurance(false)}
					/>
				)}

				{sousTraitantsModal && (
					<AtelierSousTraitantsModalV2
						closeModal={() => setSousTraitantsModal(false)}
						addAtelierLigneSousTraitant={
							addAtelierLigneSousTraitant
						}
					/>
				)}

				{inventaireModal && (
					<AtelierInventaireModalV2
						closeModal={() => setInventaireModal(false)}
						inventaire={atelierInventaire}
						typeAl={inventaireType}
						plaques={
							vehiculeSelectionne
								? vehiculeSelectionne.plaques
								: null
						}
						addAtelierLigneInventaire={addAtelierLigneInventaire}
						addAtelierLigneFourniture={addAtelierLigneFourniture}
						addAtelierLigneSousTraitantAutre={
							addAtelierLigneSousTraitantAutre
						}
					/>
				)}

				{modeleModal && (
					<AtelierModeleModalV2
						closeModal={() => setModeleModal(false)}
						listeAtelierModeles={listeAtelierModeles}
						fetchAtelierModeles={fetchModelesStatus}
						addModeleToAtelier={addModeleToAtelier}
						isSVP={form.atelier.svp}
					/>
				)}

				{facturationModal && (
					<FacturationCustomModalV2
						aFacturer={transactionsAFacturer()}
						lignesNonEnregistrees={compterNonEnregistrees(
							form.atelier.transactionsv2,
							transactionsServeur,
						)}
						onClose={() => {
							setFacturationModal(false)
							dispatch(postAtelierReset())
						}}
						updateEtatAndSave={updateEtatAndSave}
						post={atelierInfo.postAtelier}
						getAtelierJson={() =>
							getAtelierJson(buildAtelierForSave())
						}
						reloadFiche={() => setReloadCounter((c) => c + 1)}
					/>
				)}

				{cloreModal && (
					<AtelierCloreModalV2
						onConfirm={confirmClore}
						onClose={() => {
							setCloreModal(false)
							dispatch(postAtelierReset())
						}}
					/>
				)}

				{/* Modals du verrou (demande de main, demande reçue, main perdue) :
				    rendus par le hook, identiques sur les trois fiches. */}
				{verrou.VerrouUI}

				{vehiculeModal && (
					<VehiculeV2
						vehicule={vehiculeModal}
						onClose={fermerVehicule}
						depuisFiche
						enregistrer={putVehiculeFicheEntretien}
					/>
				)}

				{redirectLoc.show && (
					<AtelierCheckRedirectV2
						state={redirectLoc.state}
						error={redirectLoc.error}
						redirect={() =>
							history.push(
								`/location/fiche/${form.atelier.location}`,
							)
						}
						closeModal={() =>
							setRedirectLoc({
								show: false,
								state: 0,
								error: false,
							})
						}
					/>
				)}

				{modalRestiDep && (
					<AtelierRestiDepModalV2
						appels={appels}
						closeModal={() => setModalRestiDep(false)}
						closeModal2={() => {
							setModalRestiDep(false)
							dispatch(fetchDepPaid({ id: form.atelier.dep }))
						}}
						dispatch={dispatch}
						info={{ reste: restePayer }}
						moyenPaiements={moyenPaiements}
						depanneurs={employes}
						restiDep={restiDep}
						dep={form.atelier.dep}
					/>
				)}

				{showModalEmail && (
					<EmailModalV2
						onClose={() => setShowModalEmail(false)}
						ficheId={form.atelier.id}
						domaine={EMAIL_DOMAINE_ATELIER}
						destinataires={destinatairesEmail}
						ficheModifiee={ficheModifiee()}
					/>
				)}

				{addTransactionModal && (
					<AddTransactionModalV2
						closeModal={() => setAddTransactionModal(false)}
						addTransaction={addTransaction}
					/>
				)}

				{modifierPrixLigne && (
					<ModifierPrixModal
						ligne={modifierPrixLigne}
						isAssurance={form.atelier.isAssurance}
						onApply={applyModifierPrix}
						onClose={() => setModifierPrixLigne(null)}
					/>
				)}

				{QuitGuard}
			</div>
		</div>
	)
}
